import DateFnsUtils from "@date-io/date-fns";
import {
  AppBar,
  Button,
  Card,
  CardContent,
  Dialog as DialogMaterial,
  DialogActions,
  FormControl,
  FormGroup,
  Grid,
  Icon,
  MenuItem,
  TextField,
  Toolbar,
  Typography,
} from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import CircularProgress from "@material-ui/core/CircularProgress";
import Divider from "@material-ui/core/Divider";
import Fab from "@material-ui/core/Fab";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";
import { Visibility } from "@material-ui/icons";
import CloudUpload from "@material-ui/icons/CloudUpload";
import Search from "@material-ui/icons/Search";
import axios from "axios";
import { debounce } from "lodash";
import { InlineDatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import moment from "moment";
import NewTicket from "pages/agent-dashboard/NewTicket";
import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { connect } from "react-redux";

import { getData, getLogs, put } from "../../api/apiCaller";
import FormCampaign from "../../components/FormCampaign";
import SelectAutoComplete from "../../components/SelectAutoComplete";
import * as cookie from "../../helper/cookie";
import * as dateTime from "../../helper/date";
// import {mapActionsToProps as interactiveLogAction} from '../../redux/telesale/call';
import { mapActionsToProps as campaignAction } from "../../redux/campaigns";
import { mapActionsToProps } from "../../redux/telesale/call";
import Dialog from "./../../components/Dialog";
import TableData from "./../../components/TableData";
import product from "./../../config/product";
import select from "./../../config/select";
import datetimeHelper from "./../../helper/datetime-helper";
import { mapActionsToProps as agentAction } from "./../../redux/agent";
import { mapActionsToProps as agent } from "./../../redux/agent";
import { mapActionsToProps as clickToCallAction } from "./../../redux/cloudPBX/clickToCall";
import { mapActionsToProps as outboundCallAction } from "./../../redux/cloudPBX/outboundCall";
// import {mapActionsToProps as callLogsAction} from './../../redux/telesale/call'
import { mapActionsToProps as articelAction } from "./../../redux/miniCrm/article";
import { mapActionsToProps as commentAction } from "./../../redux/miniCrm/comment";
import { mapActionsToProps as contactAction } from "./../../redux/miniCrm/contact";
import { mapActionsToProps as indastryAction } from "./../../redux/miniCrm/indastry";
import { mapActionsToProps as knowledgeBase } from "./../../redux/miniCrm/knowledgeBase";
import { mapActionsToProps as stageAction } from "./../../redux/miniCrm/stage";
import { mapActionsToProps as ticketAction } from "./../../redux/miniCrm/ticket";

const API_PROTOCOL = process.env.REACT_APP_API_PROTOCOL || "";
const API_HOST = process.env.REACT_APP_API_HOST || "";

const styles = (theme) => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    fontWeight: "bold",
  },
  bulletOffline: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(1.8)",
    color: "red",
  },
  bulletOnline: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(1.8)",
    color: "chartreuse",
  },
  typo: {
    marginTop: theme.spacing.unit * 3,
  },
  input: {
    width: "100%",
    color: "black !important",
  },
  inputTicket: {
    width: "100%",
    marginTop: "16px",
    marginBottom: "8px",
  },
  grid: {
    alignItems: "center",
    display: "flex",
    width: "100%",
  },
  form: {
    width: "100%",
  },
  nested: {
    paddingLeft: theme.spacing.unit * 4,
  },
  rootSearch: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  inputSearch: {
    marginLeft: 8,
    flex: 1,
  },
  iconButtonSearch: {
    padding: 10,
  },
  dividerSearch: {
    width: 1,
    height: 28,
    margin: 4,
  },
  appBar: {
    position: "sticky",
  },
  flex: {
    flex: 1,
  },
  list: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    position: "relative",
    overflow: "auto",
  },
  listSection: {
    backgroundColor: "inherit",
  },
  ul: {
    backgroundColor: "inherit",
    padding: 0,
  },
});

const listCollumnsParcel = [
  { id: "no", numeric: true, disablePadding: false, label: "STT" },
  { id: "codeParcel", numeric: true, disablePadding: false, label: "Bưu gửi" },
];

const listCall = [
  { id: "Đã được đơn vị khác hỗ trợ", label: "Đã được đơn vị khác hỗ trợ" },
  {
    id: "Có quan tâm nhưng chưa sử dụng",
    label: "Có quan tâm nhưng chưa sử dụng",
  },
  { id: "Đồng ý", label: "Đồng ý" },
  { id: "Không có nhu cầu", label: "Không có nhu cầu" },
  { id: "Gọi lại sau", label: "Gọi lại sau" },
  { id: "Từ chối trả lời thông tin", label: "Từ chối trả lời thông tin" },
];

const listResult = [
  { id: "Đã xử lý", label: "Đã xử lý" },
  { id: "Đang xử lý", label: "Đang xử lý" },
];

function filterCustomers(array, search) {
  if (search) {
    return search
      ? array.filter(
          (item) =>
            item &&
            item.label &&
            item.label.toLowerCase().includes(search.toLowerCase())
        )
      : array;
  }
  return array;
}

class AgentWorkingOutbound extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    status: {
      ...this.props.status,
    },
    statusId: "",
    value: "",
    question: [],
    questions: [],
    optionsDate: { id: "", text: new Date() },
    options: [],
    optionsText: [],
    optionsCheckBox: [],
    // optionsMultiCheckBox: [{ id: '', text: '', checked: false }],
    optionsMultiCheckBox: [],
    checkedOptions: [],
    optionsSelect: [{ id: "", text: "" }],
    open: false,
    top: false,
    content: "",
    note: null,
    idQuestion: "",
    tags: "",
    data: [],
    callback: false,
    dateCallBack: null,
    stageId: "",
    openDialogTicket: false,
    ticketType: "",
    idTicket: "",
    ticket: [],
    demo: [],
    optionTicket: false,
    timeCallBack: null,
    filters: {
      order: "processedAt DESC, createdAt DESC",
      where: {
        dateFrom: null,
        dateTo: null,
        // statusId: "pending",
        type: "auto-call",
        agentId: cookie.getCookie("agentId"),
      },
      page: 0,
      pageSize: 20,
    },
    modalWorkingInfo: false,
    customer: null,
    editCustomer: true,
    editNoteCall: false,
    itemCall: null,
    indexCall: null,
    openModelEdit: false,
    stage: null,
    formQuestion: null,
    token: "",
    formId: "",
    phonenumber: "",
    common_note: "",
    isOpenTicket: false,
    isOpenCreateTicket: false,
    isShowInfoCustomer: false,
    formResult: [],
    position: null,
    pageParcel: 0,
    totalParcel: 0,
    codeParcel: null,
    itemTicket: null,
    // ticket and lead
    packages: [],
    listCall: [],
    listResult: [],
    Description: "",
    lead: {},
    Pos_Name: "",
    FileTicket: "",
    OwnerId: "",
    infoTicket: null,
    CallResult: null,
    ProcessResult: null,
    RequestDetail: "",
    campaignService: null,
    campaignGroup: null,
    campaign: null,
    isValidTicket: false,
    isValidTicketPacel: false,
    note_interactivelog: "",
    idSelectedCustomerCall: "",
  };

  async componentDidMount() {
    // await this.props.workingInfo()
    this.props.getListKnowledgeBase();
    await this.props.getListStage();
    await this.props.getStatusAgent();
    this.props.getListIndastry();
    // this.interval = setInterval(() => { return (this.workingInfoItem()) }, 1000);
    this.itemInit();
    await this.props.getAllCampaigns();
    this.props.getListStage("createdAt DESC", 999, null, null);
    this.props.getTicketType();
    this.props.getContactSF();
    this.props.getEmployeeSF();
    this.props.getPosSF();
    this.props.getProductSF();
    // this.props.getSaleOrderSF()
    this.props.getPackageSF();
    this.props.getReasonSelectList();
    this.setState({ token: cookie.getCookie("access_token") });
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  // workingInfoItem = () => {
  //     const { agentStatus } = this.props
  //     if (!!agentStatus) {
  //         this.props.workingInfo(agentStatus.extensionId)
  //     }
  // }
  itemInit() {
    const where = {};
    const and = [];
    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "campaign.name":
            case "stageId":
            case "agentId":
            default: {
              if (key.startsWith("dateFrom") || key.startsWith("dateTo")) {
                if (key == "dateFrom") {
                  and.push({
                    processedAt: { gte: this.state.filters.where.dateFrom },
                  });
                  where.and = and;
                } else {
                  and.push({
                    processedAt: { lte: this.state.filters.where.dateTo },
                  });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
    this.props.countIl({ where: where });
    this.props.getListCall(
      filters.order,
      filters.pageSize,
      filters.page,
      {
        where,
      },
      {
        include: [
          { relation: "campaign", scope: { fields: { id: true, name: true } } },
        ],
      }
    );
  }

  handleChangeForm = (e, type) => {
    e.preventDefault();
    const onClearFile = document.getElementById("fileName");
    if (onClearFile) {
      onClearFile.value = "";
    }
    const { listLogsCallTelesale } = this.props;
    const { idInteractivelog, filters } = this.state;
    let position = this.state.position;

    this.setState({
      codeParcel: null,
    });

    if (type === "submit") {
      const listLogsCallTelesaleResult =
        typeof listLogsCallTelesale === "object"
          ? Object.keys(listLogsCallTelesale).map(
              (key) => listLogsCallTelesale[key]
            )
          : listLogsCallTelesale;

      position = listLogsCallTelesaleResult.length - 1;

      if (
        this.getPosition(idInteractivelog, listLogsCallTelesaleResult) ===
        filters.pageSize - 1
      ) {
        this.onChangeRowsPerPage(20, idInteractivelog, type);
      } else if (
        this.getPosition(idInteractivelog, listLogsCallTelesaleResult) !==
        position
      ) {
        position =
          this.getPosition(idInteractivelog, listLogsCallTelesaleResult) + 1;
        this.updatePosition(position, type);
      }
    }
  };
  onChangeRowsPerPage = (increase = 20, idInteractivelog, type) => {
    const { filters } = this.state;
    const { updateNextPage, coutLogsCallTelesale } = this.props;
    filters.pageSize = filters.pageSize + increase;
    updateNextPage(coutLogsCallTelesale, true);
    this.setState(
      {
        filters,
      },
      async () => {
        // this.itemInit();
        const where = {};
        const and = [];
        const { filters } = this.state;
        for (const key in filters.where) {
          if (filters.where.hasOwnProperty(key)) {
            const element = filters.where[key];
            if (element) {
              switch (key) {
                case "campaign.name":
                case "stageId":
                case "agentId":
                default: {
                  if (key.startsWith("dateFrom") || key.startsWith("dateTo")) {
                    if (key == "dateFrom") {
                      and.push({
                        processedAt: { gte: this.state.filters.where.dateFrom },
                      });
                      where.and = and;
                    } else {
                      and.push({
                        processedAt: { lte: this.state.filters.where.dateTo },
                      });
                      where.and = and;
                    }
                  } else {
                    where[key] = element;
                  }
                  break;
                }
              }
            }
          }
        }
        const count = await getData("/mini-crm/interactive-log/count", where);
        const interactiveLog = await getLogs("/mini-crm/interactive-log", {
          order: filters.order,
          limit: filters.pageSize,
          skip: filters.page,
          where,
          include: [
            {
              relation: "campaign",
              scope: { fields: { id: true, name: true } },
            },
          ],
        });
        let position =
          this.getPosition(idInteractivelog, interactiveLog.data) + 1;
        updateNextPage(count.data, false, interactiveLog.data);
        this.updatePosition(position, type, interactiveLog.data);
      }
    );
  };

  updatePosition = (position, type) => {
    this.setState(
      {
        position,
      },
      () => {
        const { listLogsCallTelesale } = this.props;
        const listLogsCallResult =
          typeof listLogsCallTelesale === "object"
            ? Object.keys(listLogsCallTelesale).map(
                (key) => listLogsCallTelesale[key]
              )
            : listLogsCallTelesale;
        if (listLogsCallResult[position]) {
          this.setState({
            customer: listLogsCallResult[position].contact,
            idInteractivelog: listLogsCallResult[position].id,
            stage: listLogsCallResult[position].stageId,
            formQuestion: listLogsCallResult[position].form,
            formId: listLogsCallResult[position].formId
              ? listLogsCallResult[position].formId
              : "",
            phonenumber: listLogsCallResult[position].to,
            common_note:
              listLogsCallResult[position] && listLogsCallResult[position].note
                ? listLogsCallResult[position].note
                : "",
          });
          this.props.getTicketByNumber({
            phone: listLogsCallResult[position].to,
          });
          const element = document.getElementById("form-survey");
          if (element) {
            element.scrollTop = 0;
          }
        }
        if (type === "submit") {
          const { listLogsCallTelesale } = this.props;
          const callsResult =
            typeof listLogsCallTelesale === "object"
              ? Object.keys(listLogsCallTelesale).map(
                  (key) => listLogsCallTelesale[key]
                )
              : listLogsCallTelesale;

          this.handleEdit(callsResult[position], true);
          this.setState({ pageParcel: 0, totalParcel: 5 });
          let element = document.getElementById("form-campaign");
          if (element) {
            element.scrollIntoView();
          }
          const elementSurvey = document.getElementById("form-survey");
          if (elementSurvey) {
            elementSurvey.scrollTop = 0;
          }
        }
      }
    );
  };

  handleChangeText = (id) => {
    const { options } = this.state;
    return (e) => {
      const name = e.target.name;
      options[name] = e.target.value;
      this.setState({
        options,
      });
    };
  };

  handleChangeTicket = (e) => {
    const name = e.target.name;
    const { ticket } = this.state;
    ticket[name] = e.target.value;
    this.setState({
      ticket,
    });
  };

  handleChangeMultiCheck = (id, questionId) => {
    const { optionsMultiCheckBox, optionsCheckBox, checkedOptions } =
      this.state;
    const { working } = this.props;
    const result = working ? (working.result ? working.result : null) : null;
    return (e) => {
      let checkedOptions_ = checkedOptions.slice();
      let isFound = false; // checkedOptions_.find(o=>o.questionId === questionId && o.id === id);
      for (var i = checkedOptions_.length - 1; i >= 0; i--) {
        let option = checkedOptions_[i];
        if (option.questionId === questionId && option.id === id) {
          isFound = true;
          checkedOptions_.splice(i, 1);
        }
      }
      if (!isFound) {
        checkedOptions_.push({
          questionId,
          optionId: id,
          text: e.target.value,
        });
      }
      this.setState({
        checkedOptions: checkedOptions_,
      });
    };
  };

  handleChange = (name) => {
    return (e) => {
      this.setState({
        [name]: e.target.value,
      });
    };
  };

  handleChangeTime = (time) => {
    this.setState({ timeCallBack: time });
  };

  handleClick = () => {
    this.setState((state) => ({ open: !state.open }));
  };

  toggleDrawer = (side, open) => () => {
    this.setState({
      [side]: open,
    });
  };

  handleOpenArticle = async (articleId) => {
    await this.props.openAArticle(articleId);
  };

  handleComment = () => {
    const { working } = this.props;
    const result = working ? (working.result ? working.result : null) : null;
    const id = result.interactiveLog ? result.interactiveLog.id : "";
    this.props.addNewComment(id, this.state.content);
    this.setState({ content: "" });
  };

  handleNote = () => {
    const { working } = this.props;
    const result = working ? (working.result ? working.result : null) : null;
    const id = result.interactiveLog ? result.interactiveLog.id : "";
    this.props.addNoteOutboundCall(id, this.state.note);
    this.setState({ note: "" });
  };

  handleSearchKnowledgeBase = () => {
    const { tags } = this.state;
    this.props.searchKnowledgeBase(tags);
  };

  listCollumns = [
    {
      id: "campaign",
      numeric: true,
      disablePadding: false,
      label: "Chiến dịch",
    },
    {
      id: "from",
      numeric: true,
      disablePadding: false,
      label: "Số điện thoại gọi",
    },
    {
      id: "contact",
      _attributes: "fullName",
      numeric: true,
      disablePadding: false,
      label: "Tên khách hàng",
    },
    {
      id: "contact",
      numeric: true,
      disablePadding: false,
      label: "Số điện thoại nhận",
    },
    {
      id: "stage",
      numeric: true,
      disablePadding: false,
      label: "Trạng thái khách hàng",
    },
    {
      id: "logsCount",
      numeric: true,
      disablePadding: false,
      label: "Số lần gọi",
    },
    {
      id: "actionEdit",
      numeric: true,
      disablePadding: false,
      label: "Hành động",
    },
  ];
  handleChangePage = (e, page) => {
    const { filters } = this.state;
    this.setState({ page });
    filters.page = page * filters.pageSize;
    this.itemInit();
  };

  handleChangePageParcel = (e, pageParcel) => {
    this.setState({
      pageParcel,
      totalParcel: pageParcel * 5,
    });
  };

  handleSelectParcel = (parcel) => {
    const element = document.getElementById("form-survey");
    element.scrollTop = 0;
    const { arrayTicket } = this.state;
    const { updateArrayTicket } = this.props;
    this.setState(
      {
        codeParcel: parcel.code,
      },
      () => {
        this.setState({
          infoTicket: updateArrayTicket
            ? updateArrayTicket.find(
                (val) =>
                  val.customFields.packageId + "" === this.state.codeParcel + ""
              )
            : arrayTicket.find(
                (val) =>
                  val.customFields.packageId + "" === this.state.codeParcel + ""
              ),
          isValidTicketPacel:
            updateArrayTicket &&
            updateArrayTicket !== "undefined" &&
            updateArrayTicket !== null
              ? updateArrayTicket.some(
                  (val) =>
                    val.customFields.packageId + "" ===
                    this.state.codeParcel + ""
                )
              : arrayTicket &&
                arrayTicket !== undefined &&
                arrayTicket !== "undefined" &&
                arrayTicket !== null &&
                arrayTicket.some(
                  (val) =>
                    val.customFields.packageId + "" ===
                    this.state.codeParcel + ""
                ),
        });
      }
    );
  };

  handleChangeRowsPerPage = (e) => {
    const { filters } = this.state;
    filters.pageSize = e.target.value;
    this.setState(
      {
        filters,
      },
      () => {
        this.itemInit();
      }
    );
  };

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = value;
    this.setState({
      filters,
    });
  };
  handleSubmitSearch = (e) => {
    const { filters } = this.state;
    filters.skip = 0;
    this.setState({ disable: false, campaignConfig: true });
    this.itemInit();
  };

  handleDateChangeStart = (dateFrom) => {
    const { filters } = this.state;
    filters.where.dateFrom = datetimeHelper.toFormat(
      dateFrom,
      "YYYY-MM-DD HH:mm"
    );
    this.setState({ dateFrom });
  };

  handleDateChangeEnd = (dateTo) => {
    const { filters } = this.state;
    filters.where.dateTo = datetimeHelper.toFormat(dateTo, "YYYY-MM-DD HH:mm");
    this.setState({ dateTo });
  };

  callNumber = () => {
    const { agentStatus } = this.props;
    if (agentStatus.extensionId !== "-") {
      if (
        this.props.statusAgent &&
        this.props.statusAgent.id &&
        (this.props.statusAgent.id === "telesale" ||
          this.props.statusAgent.id === "manual")
      ) {
        this.props.handleClickToCall({
          interactivelogId: this.state.idInteractivelog,
          extensionId: agentStatus ? agentStatus.extensionId : null,
        });
      } else {
        this.props.pushNotiChooseStatusAgent();
      }
    } else {
      this.props.pushNotiChoosePhoneNumber();
    }
  };
  handleChangeCustomer = (name) => {
    const { listStage } = this.props;
    const listStageResult =
      typeof listStage === "object"
        ? Object.keys(listStage).map((key) => listStage[key])
        : listStage;
    return (e) => {
      this.setState(
        {
          customer: {
            ...this.state.customer,
            [name]: e.target.value,
          },
        },
        () => {
          let Description = this.state.Description.split("|");
          Description[0] =
            listStageResult &&
            listStageResult.length > 0 &&
            this.state.customer.stageId &&
            listStageResult.find(
              (item) => item.id + "" === this.state.customer.stageId + ""
            ).name;
          this.setState({
            Description: Description.join("|"),
          });
        }
      );
    };
  };

  handleEdit = (item, check) => {
    this.setState({
      idSelectedCustomerCall: item.id,
    });
    const { listLogsCallTelesale, listStage, findLead } = this.props;
    const listStageResult =
      typeof listStage === "object"
        ? Object.keys(listStage).map((key) => listStage[key])
        : listStage;
    const listLogsCallTelesaleResult =
      typeof listLogsCallTelesale === "object"
        ? Object.keys(listLogsCallTelesale).map(
            (key) => listLogsCallTelesale[key]
          )
        : listLogsCallTelesale;

    let formResult = [];
    if (
      item &&
      item.contact.packages &&
      item.contact.packages.length &&
      item.contact.packages.filter((item) => item.code).length
    ) {
      this.setState({
        codeParcel: item.contact.packages.filter((item) => item.code).length
          ? item.contact.packages.filter((item) => item.code)[0].code
          : null,
      });
      item.contact.packages
        .filter((item) => item.code)
        .forEach((pk) => {
          if (pk.code) {
            formResult.push({
              code: pk.code,
              result: item.form,
            });
          }
        });
    } else {
      formResult =
        item.formResult.length &&
        item.formResult[0].questions &&
        item.formResult[0].questions.length
          ? item.formResult
          : item.formResult.length && !item.formResult[0].questions
          ? [
              {
                note: item.note ? item.note : "",
                questions: item.formResult,
              },
            ]
          : item.form
          ? [item.form]
          : [];
    }
    this.setState(
      {
        modalWorking: check ? check : !this.state.modalWorking,
        customer: item.contact,
        idInteractivelog: item.id,
        stage: item.stageId,
        formQuestion: item.form,
        formId: item.formId ? item.formId : "",
        phonenumber: item.to,
        common_note: item && item.note ? item.note : "",
        formResult:
          item.formResult.length &&
          item.formResult[0].result &&
          item.formResult[0].result.questions &&
          item.formResult[0].result.questions.length
            ? item.formResult
            : formResult,
        // Các trường thêm cho ticket và lead
        packages:
          item &&
          item.contact &&
          item.contact.packages &&
          item.contact.packages.length > 0
            ? item.contact.packages
            : null,
        campaignService: item.campaignService ? item.campaignService : null,
        campaignGroup: item.campaignGroup ? item.campaignGroup : null,
        campaign: item.campaign ? item.campaign : null,
        // Reset các trường về mặc định khi chuyển form
        listCall: [],
        listResult: [],
        Description: "",
        lead: {},
        // Pos_Name: '',
        FileTicket: "",
        OwnerId: "",
        CallResult: null,
        ProcessResult: null,
        RequestDetail: "",
        isValidTicket: !!item.ticket,
        note_interactivelog: item.note ? item.note : "",
      },
      () => {
        if (
          item &&
          item.contact.packages &&
          item.contact.packages.length &&
          item.contact.packages.filter((item) => item.code).length
        ) {
          this.setState(
            {
              codeParcel: item.contact.packages.filter((item) => item.code)
                .length
                ? item.contact.packages.filter((item) => item.code)[0].code
                : null,
            },
            () => {
              this.setState(
                {
                  arrayTicket:
                    item &&
                    item.ticket &&
                    item.ticket !== undefined &&
                    item.ticket !== "undefined" &&
                    item.ticket !== null
                      ? item.ticket
                      : [],
                  infoTicket:
                    item &&
                    item.ticket &&
                    item.ticket !== undefined &&
                    item.ticket !== "undefined" &&
                    item.ticket !== null
                      ? item.ticket.find(
                          (val) =>
                            val.customFields.packageId + "" ===
                            this.state.codeParcel + ""
                        )
                      : null,
                  isValidTicketPacel:
                    item &&
                    item.ticket &&
                    item.ticket !== undefined &&
                    item.ticket !== "undefined" &&
                    item.ticket !== null &&
                    item.ticket.some(
                      (val) =>
                        val.customFields.packageId + "" ===
                        this.state.codeParcel + ""
                    ),
                },
                () => {
                  const { packages, infoTicket } = this.state;
                  let Description = infoTicket
                    ? infoTicket.attributes.Description.split("|")
                    : [];
                  Description[0] =
                    listStageResult &&
                    listStageResult.length > 0 &&
                    this.state.customer.stageId
                      ? listStageResult.find(
                          (item) => item.id === this.state.customer.stageId
                        ).name
                      : "";
                  this.setState({
                    Description: Description.join("|"),
                  });
                  // findLead(infoTicket && infoTicket.customFields && infoTicket.customFields.Pos_Name ? infoTicket.customFields.Pos_Name : '', 10);
                }
              );
            }
          );
          item.contact.packages
            .filter((item) => item.code)
            .forEach((pk) => {
              if (pk.code) {
                formResult.push({
                  code: pk.code,
                  result: item.form,
                });
              }
            });
        } else {
          formResult =
            item.formResult.length &&
            item.formResult[0].questions &&
            item.formResult[0].questions.length
              ? item.formResult
              : item.formResult.length && !item.formResult[0].questions
              ? [
                  {
                    note: item.note ? item.note : "",
                    questions: item.formResult,
                  },
                ]
              : item.form
              ? [item.form]
              : [];
          this.setState(
            {
              infoTicket:
                item &&
                item.ticket &&
                item.ticket !== undefined &&
                item.ticket !== "undefined" &&
                item.ticket !== null
                  ? item.ticket[0]
                  : null,
            },
            () => {
              const { infoTicket } = this.state;
              if (infoTicket) {
                this.setState({
                  CallResult: {
                    id:
                      infoTicket.customFields && infoTicket.customFields.callId,
                    label:
                      infoTicket &&
                      infoTicket.customFields &&
                      infoTicket.customFields.callName
                        ? infoTicket.customFields.callName
                        : "",
                  },
                  ProcessResult: {
                    id:
                      infoTicket.customFields &&
                      infoTicket.customFields.processId,
                    label:
                      infoTicket.customFields &&
                      infoTicket.customFields.processName
                        ? infoTicket.customFields.processName
                        : "",
                  },
                  RequestDetail:
                    infoTicket &&
                    infoTicket.customFields &&
                    infoTicket.customFields.RequestDetail
                      ? infoTicket.customFields.RequestDetail
                      : infoTicket && infoTicket.attributes
                      ? infoTicket.attributes.Description.split("|")[2]
                      : "",
                  OwnerId:
                    infoTicket &&
                    infoTicket.attributes &&
                    infoTicket.attributes.OwnerId
                      ? infoTicket.attributes.OwnerId
                      : "",
                  Pos_Name:
                    infoTicket &&
                    infoTicket.customFields &&
                    infoTicket.customFields.Pos_Name
                      ? infoTicket.customFields.Pos_Name
                      : "",
                });
              }

              let Description = infoTicket
                ? infoTicket.attributes.Description.split("|")
                : [];

              Description[0] =
                listStageResult &&
                listStageResult.length > 0 &&
                this.state.customer.stageId
                  ? listStageResult.find(
                      (item) => item.id === this.state.customer.stageId
                    ).name
                  : "";
              this.setState({
                Description: Description.join("|"),
              });
              findLead(
                infoTicket &&
                  infoTicket.customFields &&
                  infoTicket.customFields.Pos_Name
                  ? infoTicket.customFields.Pos_Name
                  : "",
                10
              );
            }
          );
        }
      }
    );
    //this.props.getTicketByNumber({ phone: item.to });
    this.getPosition(item.id, listLogsCallTelesaleResult);
  };

  handleSaveCustomer = () => {
    const { customer, idInteractivelog } = this.state;
    this.props.updateForm(
      idInteractivelog,
      "",
      { contact: customer },
      this.state.note_interactivelog,
      customer.stageId
    );
  };

  handleClose = () => {
    this.setState({ modalWorking: false, customer: false, codeParcel: null });
    this.itemInit();
  };

  itemTicket = (item) => {
    let data = [];
    this.state.itemTicket = item;
    this.setState({ modalAction: true });
    if (item) {
      if (item.id) {
        for (const key in item.attributes) {
          if (item.attributes.hasOwnProperty(key)) {
            const element = item.attributes[key];
            select.menu_search.filter((i) => {
              if (i.name !== key) return i;
              return data.push({
                name: i.label,
                value: element,
              });
            });
          }
        }
        this.setState({ ticket: data });
      }
    }
  };

  onUpdateSate = (value, id, id_item) => {
    const { formResult, codeParcel } = this.state;
    const array = codeParcel
      ? JSON.parse(JSON.stringify(formResult)).filter(
          (item) => item.code === codeParcel
        )[0]
      : formResult;
    if (array && array.result && array.result.questions.length > 0) {
      array.result.questions.forEach((quiz) => {
        // Trường hợp chọn tham chiếu
        if (
          quiz.type === "select-list" &&
          quiz.id === id &&
          id_item === "refer"
        ) {
          quiz.options = {
            ...quiz.options,
            refer: value,
          };
        }

        // Trường hợp chọn nội dung của tham chiếu
        if (
          quiz.type === "select-list" &&
          quiz.id === id &&
          id_item === "content"
        ) {
          quiz.options = {
            ...quiz.options,
            data: value,
          };
          const prefix = quiz.options.refer ? quiz.options.refer + "_" : "";
          quiz.selected = prefix + value;
        }

        // Trường hợp multi-check-box
        if (quiz.type === "multi-check-box" && quiz.id === id) {
          let checked =
            quiz.checked && quiz.checked.length > 0 ? quiz.checked : [];
          quiz.options.forEach((item) => {
            if (item.id === value) {
              const isValid = checked.some((item) => item.id === value);
              if (isValid) {
                checked = checked.filter((rm) => rm.id !== value);
              } else {
                checked.push(item);
              }
              quiz.checked = checked;
              quiz.selected = checked.map((value) => value.text).toString(",");
            }
          });
        }

        // Trường hợp check-box
        if (quiz.type === "check-box" && quiz.id === id) {
          quiz.options = quiz.options.map((item) => {
            if (item.id === id_item) {
              quiz.selected = value === true ? "Đồng ý" : "Không đồng ý";
              return {
                ...item,
                text: value,
              };
            }
            return item;
          });
        }

        // Trường hợp select
        if (quiz.type === "select" && quiz.id === id) {
          quiz.selected_id = value;
          quiz.options.forEach((selected) => {
            if (selected.id === value) {
              quiz.selected = selected.text;
            }
          });
        }

        // Trường hợp scale
        if (quiz.type === "scale" && quiz.id === id) {
          quiz.selected = value;
        }

        // Trường hợp datetime
        if (quiz.type === "datetime" && quiz.id === id) {
          quiz.options = quiz.options.map((item) => {
            if (item.id === id_item) {
              quiz.selected = dateTime.formatDate(
                value,
                dateTime.dateFormats.isoDate
              );
              return {
                ...item,
                text: value,
              };
            }
            return item;
          });
        }

        // Trường hợp time
        if (quiz.type === "time" && quiz.id === id) {
          quiz.options = quiz.options.map((item) => {
            if (item.id === id_item) {
              quiz.selected = dateTime.formatDate(
                value,
                dateTime.dateFormats.isoDate
              );
              return {
                ...item,
                text: value,
              };
            }
            return item;
          });
        }

        // Trường hợp date
        if (quiz.type === "date" && quiz.id === id) {
          quiz.options = quiz.options.map((item) => {
            if (item.id === id_item) {
              quiz.selected = dateTime.formatDate(
                value,
                dateTime.dateFormats.isoDate
              );
              return {
                ...item,
                text: value,
              };
            }
            return item;
          });
        }

        // Trường hợp file
        if (quiz.type === "file" && quiz.id === id) {
          quiz.options = quiz.options.map((item) => {
            if (item.id === id_item) {
              quiz.selected = `${API_PROTOCOL}://${API_HOST}/media-mgt/container/mini-crm/download/${value}`;
              return {
                ...item,
                text: value,
              };
            }
            return item;
          });
        }

        // Trường hợp còn lại
        if (
          quiz.type !== "select-list" &&
          quiz.type !== "check-box" &&
          quiz.type !== "datetime" &&
          quiz.type !== "time" &&
          quiz.type !== "date" &&
          quiz.type !== "scale" &&
          quiz.type !== "select" &&
          quiz.type !== "check-box" &&
          quiz.type !== "multi-check-box" &&
          quiz.type !== "file" &&
          quiz.id === id
        ) {
          quiz.options = quiz.options.map((item) => {
            if (item.id === id_item) {
              quiz.selected = value;
              return {
                ...item,
                text: value,
              };
            }
            return item;
          });
        }
      });
      this.setState({
        formResult: formResult.map((item) => {
          if (item.code === array.code) {
            return array;
          }
          return item;
        }),
      });
    } else if (
      array &&
      array.length &&
      array[0].questions &&
      array[0].questions.length
    ) {
      array[0].questions.forEach((quiz) => {
        // Trường hợp chọn tham chiếu
        if (
          quiz.type === "select-list" &&
          quiz.id === id &&
          id_item === "refer"
        ) {
          quiz.options = {
            ...quiz.options,
            refer: value,
          };
        }

        // Trường hợp chọn nội dung của tham chiếu
        if (
          quiz.type === "select-list" &&
          quiz.id === id &&
          id_item === "content"
        ) {
          quiz.options = {
            ...quiz.options,
            data: value,
          };
          const prefix = quiz.options.refer ? quiz.options.refer + "_" : "";
          quiz.selected = prefix + value;
        }

        // Trường hợp multi-check-box
        if (quiz.type === "multi-check-box" && quiz.id === id) {
          let checked =
            quiz.checked && quiz.checked.length > 0 ? quiz.checked : [];
          quiz.options.forEach((item) => {
            if (item.id === value) {
              const isValid = checked.some((item) => item.id === value);
              if (isValid) {
                checked = checked.filter((rm) => rm.id !== value);
              } else {
                checked.push(item);
              }
              quiz.checked = checked;
              quiz.selected = checked.map((value) => value.text).toString(",");
            }
          });
        }

        // Trường hợp check-box
        if (quiz.type === "check-box" && quiz.id === id) {
          quiz.options = quiz.options.map((item) => {
            if (item.id === id_item) {
              quiz.selected = value === true ? "Đồng ý" : "Không đồng ý";
              return {
                ...item,
                text: value,
              };
            }
            return item;
          });
        }

        // Trường hợp select
        if (quiz.type === "select" && quiz.id === id) {
          quiz.selected_id = value;
          quiz.options.forEach((selected) => {
            if (selected.id === value) {
              quiz.selected = selected.text;
            }
          });
        }

        // Trường hợp scale
        if (quiz.type === "scale" && quiz.id === id) {
          quiz.selected = value;
        }

        // Trường hợp datetime
        if (quiz.type === "datetime" && quiz.id === id) {
          quiz.options = quiz.options.map((item) => {
            if (item.id === id_item) {
              quiz.selected = dateTime.formatDate(
                value,
                dateTime.dateFormats.isoDate
              );
              return {
                ...item,
                text: value,
              };
            }
            return item;
          });
        }

        // Trường hợp time
        if (quiz.type === "time" && quiz.id === id) {
          quiz.options = quiz.options.map((item) => {
            if (item.id === id_item) {
              quiz.selected = dateTime.formatDate(
                value,
                dateTime.dateFormats.isoDate
              );
              return {
                ...item,
                text: value,
              };
            }
            return item;
          });
        }

        // Trường hợp date
        if (quiz.type === "date" && quiz.id === id) {
          quiz.options = quiz.options.map((item) => {
            if (item.id === id_item) {
              quiz.selected = dateTime.formatDate(
                value,
                dateTime.dateFormats.isoDate
              );
              return {
                ...item,
                text: value,
              };
            }
            return item;
          });
        }

        // Trường hợp file
        if (quiz.type === "file" && quiz.id === id) {
          quiz.options = quiz.options.map((item) => {
            if (item.id === id_item) {
              quiz.selected = `${API_PROTOCOL}://${API_HOST}/media-mgt/container/mini-crm/download/${value}`;
              return {
                ...item,
                text: value,
              };
            }
            return item;
          });
        }

        // Trường hợp còn lại
        if (
          quiz.type !== "select-list" &&
          quiz.type !== "check-box" &&
          quiz.type !== "datetime" &&
          quiz.type !== "time" &&
          quiz.type !== "date" &&
          quiz.type !== "scale" &&
          quiz.type !== "select" &&
          quiz.type !== "check-box" &&
          quiz.type !== "multi-check-box" &&
          quiz.type !== "file" &&
          quiz.id === id
        ) {
          quiz.options = quiz.options.map((item) => {
            if (item.id === id_item) {
              quiz.selected = value;
              return {
                ...item,
                text: value,
              };
            }
            return item;
          });
        }
      });
      this.setState({
        formResult: array,
      });
    }
  };

  onUpdateComment = (value, id) => {
    const { formResult, codeParcel } = this.state;
    const array = codeParcel
      ? JSON.parse(JSON.stringify(formResult)).filter(
          (item) => item.code === codeParcel
        )[0]
      : formResult;

    if (array && array.result && array.result.questions.length > 0) {
      array.result.questions.forEach((quiz) => {
        if (quiz.id === id) {
          quiz.note = value;
        }
      });
      this.setState({
        formResult: formResult.map((item) => {
          if (item.code === array.code) {
            return array;
          }
          return item;
        }),
      });
    } else if (
      array &&
      array.length &&
      array[0].questions &&
      array[0].questions.length
    ) {
      array[0].questions.forEach((quiz) => {
        if (quiz.id === id) {
          quiz.note = value;
        }
      });
      this.setState({
        formResult: array,
      });
    }
  };

  renderQuestion = () => {
    const { classes, reasonSelectList } = this.props;
    const { token, formResult, codeParcel } = this.state;
    let array = [];
    if (codeParcel) {
      array = formResult.filter((form) => form.code === codeParcel)[0];
    } else {
      array = formResult;
    }

    if (array && array.result && array.result.questions.length > 0) {
      return array.result.questions.map((question, index) => {
        return (
          <FormCampaign
            key={index}
            index={index}
            id={question.id}
            type={question.type}
            title={question.title}
            note={question.note}
            options={question.options}
            question={question}
            disabled={false}
            classes={classes}
            reasonSelectList={reasonSelectList}
            token={token}
            onUpdateSate={this.onUpdateSate}
            onUpdateComment={this.onUpdateComment}
            layout={12}
          />
        );
      });
    } else if (
      array &&
      array.length &&
      array[0].questions &&
      array[0].questions.length
    ) {
      return array[0].questions.map((question, index) => {
        return (
          <FormCampaign
            key={index}
            index={index}
            id={question.id}
            type={question.type}
            title={question.title}
            note={question.note}
            options={question.options}
            question={question}
            classes={classes}
            reasonSelectList={reasonSelectList}
            token={token}
            onUpdateSate={this.onUpdateSate}
            onUpdateComment={this.onUpdateComment}
            layout={12}
          />
        );
      });
    }
  };

  handleSelectTicket = (name) => {
    return (e) => {
      this.setState(
        {
          [name]: e.target.value,
        },
        () => {
          if (this.props.ticketType != undefined) {
            const ticket = this.props.ticketType.filter(
              (item) => item.refId == e.target.value
            );
            if (ticket) {
              this.setState({ idTicket: ticket[0].id, optionTicket: true });
            }
          }
          this.setState({
            ticket: [],
          });
        }
      );
    };
  };

  renderTicket = () => {
    const { classes, loadingInfo, infoCustomer, logInboundOutbound } =
      this.props;
    const { customer } = this.state;

    switch (this.state.ticketType) {
      case "khieu-nai": {
        return (
          <React.Fragment>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Divider />
              <Typography
                style={{
                  backgroundColor: "#d3d4d9",
                  padding: "5px 15px",
                  fontSize: 18,
                }}>
                Thông tin trường hợp
              </Typography>
              <Grid container>
                <Grid item md={6} style={{ paddingRight: 10 }}>
                  <Typography>Chủ trường hợp</Typography>
                  <Typography>Số trường hợp</Typography>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Mã bưu gửi"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="Package_text__c"
                    value={this.state.ticket.Package_text__c}
                    validators={["required"]}
                    required
                    errorMessages={[`Không được để trống`]}
                  />

                  <SelectValidator
                    id="outlined-full-width"
                    margin="normal"
                    select
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu,
                        shrink: true,
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Dịch vụ sử dụng"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    value={this.state.ticket.Service__c}
                    name="Service__c"
                    validators={["required"]}
                    required
                    errorMessages={[`Không được để trống`]}>
                    {product.results.map((item, key) => {
                      return (
                        <MenuItem key={key} value={item.Id}>
                          {item.Name}
                        </MenuItem>
                      );
                    })}
                  </SelectValidator>
                  <SelectValidator
                    id="outlined-full-width"
                    margin="normal"
                    select
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu,
                        shrink: true,
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Phạm vi bưu gửi"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    value={this.state.ticket.Location_Type__c}
                    name="Location_Type__c"
                    validators={["required"]}
                    required
                    errorMessages={[`Không được để trống`]}>
                    <MenuItem key="Trong nước" value="Trong nước">
                      Trong nước
                    </MenuItem>

                    <MenuItem key="Quốc tế" value="Quốc tế">
                      Quốc tế
                    </MenuItem>
                  </SelectValidator>
                  <InlineDatePicker
                    margin="normal"
                    label="Ngày tiếp nhận"
                    variant="outlined"
                    className={classes.input}
                    value={this.state.ticket.Nga_y_ti_p_nh_n__c}
                    format="yyyy/MM/dd"
                    // onChange={this.handleDateChangeEnd}
                    name="Nga_y_ti_p_nh_n__c"
                    keyboard
                    ampm={false}
                    mask={[
                      /\d/,
                      /\d/,
                      /\d/,
                      /\d/,
                      "/",
                      /\d/,
                      /\d/,
                      "/",
                      /\d/,
                      /\d/,
                    ]}
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Chủ đề"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="Subject"
                    value={this.state.ticket.Subject}
                    validators={["required"]}
                    required
                    errorMessages={[`Không được để trống`]}
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Mô tả"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="Description"
                    value={this.state.ticket.Description}
                    multiline
                    rows={5}
                    validators={["required"]}
                    required
                    errorMessages={[`Không được để trống`]}
                  />
                  <SelectValidator
                    id="outlined-full-width"
                    margin="normal"
                    select
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu,
                        shrink: true,
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="POS đơn vị chủ trì"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    value={this.state.ticket.POS_Chu_Tri__c}
                    name="POS_Chu_Tri__c"
                    validators={["required"]}
                    required
                    errorMessages={[`Không được để trống`]}>
                    {this.props.pos !== undefined ? (
                      this.props.pos.map((item, key) => {
                        return (
                          <MenuItem key={key} value={item.Id}>
                            {item.Name}
                          </MenuItem>
                        );
                      })
                    ) : (
                      <React.Fragment />
                    )}
                  </SelectValidator>
                </Grid>
                <Grid item md={6} style={{ paddingLeft: 10 }}>
                  <Typography>
                    Loại hồ sơ trường hợp: Phản ánh khiếu nại
                  </Typography>
                  <SelectValidator
                    id="outlined-full-width"
                    margin="normal"
                    select
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu,
                        shrink: true,
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Nhóm dịch vụ"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    value={this.state.ticket.Nhom_dich_vu__c}
                    name="Nhom_dich_vu__c"
                    validators={["required"]}
                    required
                    errorMessages={[`Không được để trống`]}>
                    <MenuItem
                      key="Dịch vụ bưu chính chuyển phát"
                      value="Dịch vụ bưu chính chuyển phát">
                      Dịch vụ bưu chính chuyển phát
                    </MenuItem>

                    <MenuItem
                      key="Dịch vụ tài chính bưu chính"
                      value="Dịch vụ tài chính bưu chính">
                      Dịch vụ tài chính bưu chính
                    </MenuItem>
                    <MenuItem
                      key="Dịch vụ phân phối truyền thông"
                      value="Dịch vụ phân phối truyền thông">
                      Dịch vụ phân phối truyền thông
                    </MenuItem>
                    <MenuItem
                      key="Dịch vụ hành chính công"
                      value="Dịch vụ hành chính công">
                      Dịch vụ hành chính công
                    </MenuItem>
                  </SelectValidator>
                  <SelectValidator
                    id="outlined-full-width"
                    margin="normal"
                    select
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu,
                        shrink: true,
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Nội dung khiếu nại"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    value={this.state.ticket.Li_do_khieu_nai__c}
                    name="Li_do_khieu_nai__c"
                    validators={["required"]}
                    required
                    errorMessages={[`Không được để trống`]}>
                    {select.ly_do_khieu_nai.map((item) => {
                      return (
                        <MenuItem key={item.id} value={item.name}>
                          {item.name}
                        </MenuItem>
                      );
                    })}
                  </SelectValidator>

                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Mã khách hàng di sản"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="Ma_khach_hang__c"
                    value={this.state.ticket.Ma_khach_hang__c}
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Pháp nhân"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="Pha_p_nh_n__c"
                    value={this.state.ticket.Pha_p_nh_n__c}
                  />
                </Grid>
              </Grid>
              <Divider />
              <Typography
                style={{
                  backgroundColor: "#d3d4d9",
                  padding: "5px 15px",
                  fontSize: 18,
                }}>
                Chi tiết liên hệ
              </Typography>
              <Grid container>
                <Grid item md={6} style={{ paddingRight: 10 }}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Địa chỉ chi tiết người liên hệ"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="Contact_address__c"
                    value={this.state.ticket.Contact_address__c}
                    multiline
                    rows={5}
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Phường xã liên hệ"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="Contact_commune__r"
                    value={this.state.ticket.Contact_commune__r}
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Quận huyện người liên hệ"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="Contact_district__r"
                    value={this.state.ticket.Contact_district__r}
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Tỉnh thành người liên hệ"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="Contact_province__r"
                    value={this.state.ticket.Contact_province__r}
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Quốc gia người liên hệ"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="Contact_nation__r"
                    value={this.state.ticket.Contact_nation__r}
                  />
                </Grid>
                <Grid item md={6} style={{ paddingLeft: 10 }}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Tên người khiếu nại"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="SuppliedName"
                    value={
                      customer
                        ? customer.fullName !== ""
                          ? customer.fullName
                          : this.state.ticket.SuppliedName
                        : this.state.ticket.SuppliedName
                    }
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Số điện thoại"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="SuppliedPhone"
                    value={` ${
                      customer
                        ? customer.phoneNumber !== ""
                          ? customer.phoneNumber
                          : this.props.listActiveCall[0]
                          ? this.props.listActiveCall[0].from
                          : this.props.logInboundOutbound.length != 0
                          ? logInboundOutbound[0].numberFrom
                          : this.state.ticket.SuppliedPhone
                        : this.state.ticket.SuppliedPhone
                    }`}
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Công ty"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="SuppliedCompany"
                    value={this.state.ticket.SuppliedCompany}
                  />
                </Grid>
              </Grid>
              <Divider />
              <Typography
                style={{
                  backgroundColor: "#d3d4d9",
                  padding: "5px 15px",
                  fontSize: 18,
                }}>
                Chuyển hỗ trợ
              </Typography>
              <Grid container>
                <Grid item md={6} style={{ paddingLeft: 10 }}>
                  <SelectValidator
                    id="outlined-full-width"
                    margin="normal"
                    select
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu,
                        shrink: true,
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Mã đơn vị tiếp nhận"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    value={this.state.ticket.Post_Office__c}
                    name="Post_Office__c"
                    validators={["required"]}
                    required
                    errorMessages={[`Không được để trống`]}>
                    {this.props.pos !== undefined ? (
                      this.props.pos.map((item, key) => {
                        return (
                          <MenuItem key={key} value={item.Id}>
                            {item.Name}
                          </MenuItem>
                        );
                      })
                    ) : (
                      <React.Fragment />
                    )}
                  </SelectValidator>
                </Grid>
              </Grid>
              <Divider />
              <Typography
                style={{
                  backgroundColor: "#bbbcc4",
                  padding: "5px 15px",
                  fontSize: 18,
                }}>
                Thông tin bổ sung
              </Typography>
              <SelectValidator
                id="outlined-full-width"
                margin="normal"
                select
                SelectProps={{
                  MenuProps: {
                    className: classes.menu,
                    shrink: true,
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                label="Trạng thái"
                variant="outlined"
                className={classes.input}
                onChange={this.handleChangeTicket}
                value={this.state.ticket.Status}
                name="Status"
                validators={["required"]}
                required
                errorMessages={[`Không được để trống`]}>
                <MenuItem key="Mới tạo" value="Mới tạo">
                  Mới tạo
                </MenuItem>
                <MenuItem key="Đã tiếp nhận" value="Đã tiếp nhận">
                  Đã tiếp nhận
                </MenuItem>
                <MenuItem key="Đang xử lí" value="Đang xử lí">
                  Đang xử lí
                </MenuItem>
                <MenuItem key="Đã có kết quả" value="Đã có kết quả">
                  Đã có kết quả
                </MenuItem>
                <MenuItem key="Đã hoàn thành" value="Đã hoàn thành">
                  Đã hoàn thành
                </MenuItem>
                <MenuItem key="Hủy" value="Hủy">
                  Hủy
                </MenuItem>
                <MenuItem key="Mở lại" value="Mở lại">
                  Mở lại
                </MenuItem>
              </SelectValidator>
              <SelectValidator
                id="outlined-full-width"
                margin="normal"
                select
                SelectProps={{
                  MenuProps: {
                    className: classes.menu,
                    shrink: true,
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                label="Nguồn gốc của TH"
                variant="outlined"
                className={classes.input}
                onChange={this.handleChangeTicket}
                value={this.state.ticket.Origin}
                name="Origin"
                validators={["required"]}
                required
                errorMessages={[`Không được để trống`]}>
                {select.origin.map((item) => {
                  return (
                    <MenuItem key={item.name} value={item.name}>
                      {item.name}
                    </MenuItem>
                  );
                })}
              </SelectValidator>
              <SelectValidator
                id="outlined-full-width"
                margin="normal"
                select
                SelectProps={{
                  MenuProps: {
                    className: classes.menu,
                    shrink: true,
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                label="Mức độ ưu tiên"
                variant="outlined"
                className={classes.input}
                onChange={this.handleChangeTicket}
                value={this.state.ticket.Priority}
                name="Priority"
                validators={["required"]}
                required
                errorMessages={[`Không được để trống`]}>
                <MenuItem key="Cao" value="Cao">
                  Cao
                </MenuItem>
                <MenuItem key="Trung bình" value="Trung bình">
                  Trung bình
                </MenuItem>
                <MenuItem key="Thấp" value="Thấp">
                  Thấp
                </MenuItem>
              </SelectValidator>
            </MuiPickersUtilsProvider>
            <DialogActions>
              <Button
                onClick={() =>
                  this.setState({
                    openDialogTicket: false,
                    optionTicket: false,
                  })
                }
                color="secondary"
                className={classes.button}>
                Hủy
              </Button>

              <Button
                type="submit"
                variant="contained"
                color="primary"
                className={classes.button}>
                Lưu
              </Button>
            </DialogActions>
          </React.Fragment>
        );
      }
      case "ho-tro": {
        return (
          <React.Fragment>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Divider />
              <Typography
                style={{
                  backgroundColor: "#d3d4d9",
                  padding: "5px 15px",
                  fontSize: 18,
                }}>
                Thông tin trường hợp
              </Typography>
              <Grid container>
                <Grid item md={6} style={{ paddingRight: 10 }}>
                  <Typography>Số trường hợp</Typography>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Mã bưu gửi"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="Package_text__c"
                    value={this.state.ticket.Package_text__c}
                    validators={["required"]}
                    required
                    errorMessages={[`Không được để trống`]}
                  />
                  <SelectValidator
                    id="outlined-full-width"
                    margin="normal"
                    select
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu,
                        shrink: true,
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Dịch vụ sử dụng"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    value={this.state.ticket.Service__c}
                    name="Service__c"
                    validators={["required"]}
                    required
                    errorMessages={[`Không được để trống`]}>
                    {product.results.map((item, key) => {
                      return (
                        <MenuItem key={key} value={item.Id}>
                          {item.Name}
                        </MenuItem>
                      );
                    })}
                  </SelectValidator>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Chủ đề"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="Subject"
                    value={this.state.ticket.Subject}
                    validators={["required"]}
                    required
                    errorMessages={[`Không được để trống`]}
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Mô tả"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="Description"
                    value={this.state.ticket.Description}
                    multiline
                    rows={5}
                    validators={["required"]}
                    required
                    errorMessages={[`Không được để trống`]}
                  />
                </Grid>
                <Grid item md={6} style={{ paddingLeft: 10 }}>
                  <Typography>Chủ trường hợp: Nhân viên chăm sóc</Typography>
                  <SelectValidator
                    id="outlined-full-width"
                    margin="normal"
                    select
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu,
                        shrink: true,
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Nội dung hỗ trợ"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    value={this.state.ticket.Noi_dung_ho_tro__c}
                    name="Noi_dung_ho_tro__c"
                    validators={["required"]}
                    required
                    errorMessages={[`Không được để trống`]}>
                    {select.noi_dung_ho_tro.map((item) => {
                      return (
                        <MenuItem key={item.name} value={item.name}>
                          {item.name}
                        </MenuItem>
                      );
                    })}
                  </SelectValidator>
                  {/* <SelectValidator
                                id="outlined-full-width"
                                margin="normal"
                                select
                                SelectProps={{
                                    MenuProps: {
                                        className: classes.menu,
                                        shrink: true,
                                    },
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                label="Tên tài khoản"
                                variant="outlined"
                                className={classes.input}
                                onChange={this.handleChangeTicket}
                                value={this.state.ticket.Employee__c}
                                name="Employee__c"
                            >
                                {
                                    this.props.employee!== undefined ? this.props.employee.map(item => {
                                        return (

                                            <MenuItem key={item.Id} value={item.Id}>
                                                {item.Name}
                                            </MenuItem>
                                        )
                                    }) : <React.Fragment />
                                }

                            </SelectValidator> */}
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Mã khách hàng di sản"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="Ma_khach_hang__c"
                    value={this.state.ticket.Ma_khach_hang__c}
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Pháp nhân"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="Pha_p_nh_n__c"
                    value={this.state.ticket.Pha_p_nh_n__c}
                  />
                  {/* <TextValidator
                                id="outlined-full-width"
                                margin="normal"
                                label="Tên người liên hệ"
                                variant="outlined"
                                className={classes.input}
                                onChange={this.handleChangeTicket}
                                name="SuppliedName"
                                value={this.state.ticket.SuppliedName}
                            /> */}
                </Grid>
              </Grid>
              <Divider />
              <Typography
                style={{
                  backgroundColor: "#d3d4d9",
                  padding: "5px 15px",
                  fontSize: 18,
                }}>
                Chuyển hỗ trợ
              </Typography>
              <Grid container>
                <Grid item md={6} style={{ paddingLeft: 10 }}>
                  <SelectValidator
                    id="outlined-full-width"
                    margin="normal"
                    select
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu,
                        shrink: true,
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Mã đơn vị tiếp nhận"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    value={this.state.ticket.Post_Office__c}
                    name="Post_Office__c">
                    {this.props.pos !== undefined ? (
                      this.props.pos.map((item, key) => {
                        return (
                          <MenuItem key={key} value={item.Id}>
                            {item.Name}
                          </MenuItem>
                        );
                      })
                    ) : (
                      <React.Fragment />
                    )}
                  </SelectValidator>
                </Grid>
              </Grid>
              <Divider />
              <Typography
                style={{
                  backgroundColor: "#d3d4d9",
                  padding: "5px 15px",
                  fontSize: 18,
                }}>
                Thông tin liên hệ
              </Typography>
              <Grid container>
                <Grid item md={6} style={{ paddingRight: 10 }}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Địa chỉ chi tiết người liên hệ"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="Contact_address__c"
                    value={this.state.ticket.Contact_address__c}
                    multiline
                    rows={5}
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Phường xã liên hệ"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="Contact_commune__r"
                    value={this.state.ticket.Contact_commune__r}
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Quận huyện người liên hệ"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="Contact_district__r"
                    value={this.state.ticket.Contact_district__r}
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Tỉnh thành người liên hệ"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="Contact_province__r"
                    value={this.state.ticket.Contact_province__r}
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Quốc gia người liên hệ"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="Contact_nation__r"
                    value={this.state.ticket.Contact_nation__r}
                  />
                </Grid>
                <Grid item md={6} style={{ paddingLeft: 10 }}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Tên người khiếu nại"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="SuppliedName"
                    value={
                      loadingInfo == true
                        ? infoCustomer.name !== ""
                          ? infoCustomer.name
                          : this.state.ticket.SuppliedName
                        : this.state.ticket.SuppliedName
                    }
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Số điện thoại"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="SuppliedPhone"
                    value={` ${
                      loadingInfo == true
                        ? infoCustomer.phone !== ""
                          ? infoCustomer.phone
                          : this.props.listActiveCall[0]
                          ? this.props.listActiveCall[0].from
                          : this.props.logInboundOutbound.length != 0
                          ? logInboundOutbound[0].numberFrom
                          : this.state.ticket.SuppliedPhone
                        : this.state.ticket.SuppliedPhone
                    }`}
                  />
                  {/* <TextValidator
                                id="outlined-full-width"
                                margin="normal"
                                label="Email"
                                variant="outlined"
                                className={classes.input}
                                onChange={this.handleChangeTicket}
                                name="SuppliedEmail"
                                value={loadingInfo == true ? infoCustomer.email !== '' ? infoCustomer.email : this.state.ticket.SuppliedEmail : this.state.ticket.SuppliedEmail}
                                type="email"
                            /> */}
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Công ty"
                    variant="outlined"
                    className={classes.input}
                    // onChange={this.handleChangeTicket}
                    // name="Contact_nation__r"
                    // value={this.state.ticket.Contact_nation__r}
                  />
                </Grid>
              </Grid>
              <Divider />
              <Typography
                style={{
                  backgroundColor: "#bbbcc4",
                  padding: "5px 15px",
                  fontSize: 18,
                }}>
                Thông tin bổ sung
              </Typography>
              <SelectValidator
                id="outlined-full-width"
                margin="normal"
                select
                SelectProps={{
                  MenuProps: {
                    className: classes.menu,
                    shrink: true,
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                label="Trạng thái"
                variant="outlined"
                className={classes.input}
                onChange={this.handleChangeTicket}
                value={this.state.ticket.Status}
                name="Status"
                validators={["required"]}
                required
                errorMessages={[`Không được để trống`]}>
                <MenuItem key="Mới tạo" value="Mới tạo">
                  Mới tạo
                </MenuItem>
                <MenuItem key="Đã tiếp nhận" value="Đã tiếp nhận">
                  Đã tiếp nhận
                </MenuItem>
                <MenuItem key="Đang xử lí" value="Đang xử lí">
                  Đang xử lí
                </MenuItem>
                <MenuItem key="Đã có kết quả" value="Đã có kết quả">
                  Đã có kết quả
                </MenuItem>
                <MenuItem key="Đã hoàn thành" value="Đã hoàn thành">
                  Đã hoàn thành
                </MenuItem>
                <MenuItem key="Hủy" value="Hủy">
                  Hủy
                </MenuItem>
                <MenuItem key="Mở lại" value="Mở lại">
                  Mở lại
                </MenuItem>
              </SelectValidator>
              <SelectValidator
                id="outlined-full-width"
                margin="normal"
                select
                SelectProps={{
                  MenuProps: {
                    className: classes.menu,
                    shrink: true,
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                label="Nguồn gốc của TH"
                variant="outlined"
                className={classes.input}
                onChange={this.handleChangeTicket}
                value={this.state.ticket.Origin}
                name="Origin"
                validators={["required"]}
                required
                errorMessages={[`Không được để trống`]}>
                {select.origin.map((item) => {
                  return (
                    <MenuItem key={item.name} value={item.name}>
                      {item.name}
                    </MenuItem>
                  );
                })}
              </SelectValidator>
              <SelectValidator
                id="outlined-full-width"
                margin="normal"
                select
                SelectProps={{
                  MenuProps: {
                    className: classes.menu,
                    shrink: true,
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                label="Mức độ ưu tiên"
                variant="outlined"
                className={classes.input}
                onChange={this.handleChangeTicket}
                value={this.state.ticket.Priority}
                name="Priority"
                validators={["required"]}
                required
                errorMessages={[`Không được để trống`]}>
                <MenuItem key="Cao" value="Cao">
                  Cao
                </MenuItem>
                <MenuItem key="Trung bình" value="Trung bình">
                  Trung bình
                </MenuItem>
                <MenuItem key="Thấp" value="Thấp">
                  Thấp
                </MenuItem>
              </SelectValidator>
            </MuiPickersUtilsProvider>
            <DialogActions>
              <Button
                onClick={() =>
                  this.setState({
                    openDialogTicket: false,
                    optionTicket: false,
                  })
                }
                color="secondary"
                className={classes.button}>
                Hủy
              </Button>
              {/* <Button type="submit" fullWidth color="primary" className={classes.submit} onClick={this.handleChangeTicketAndReload}>
                                Lưu và thoát
                                </Button> */}

              <Button
                type="submit"
                variant="contained"
                color="primary"
                className={classes.button}>
                Lưu
              </Button>
            </DialogActions>
          </React.Fragment>
        );
      }
      case "tu-van": {
        return (
          <React.Fragment>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Typography
                style={{
                  backgroundColor: "#bbbcc4",
                  padding: "5px 15px",
                  fontSize: 18,
                }}>
                Thông tin trường hợp
              </Typography>
              <Grid container>
                <Grid item md={6} style={{ paddingRight: 10 }}>
                  <Typography>Số trường hợp</Typography>
                  <Typography>Chủ trường hợp: Nhân viên chăm sóc</Typography>
                  <SelectValidator
                    id="outlined-full-width"
                    margin="normal"
                    select
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu,
                        shrink: true,
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Dịch vụ sử dụng"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    value={this.state.ticket.Service__c}
                    name="Service__c"
                    validators={["required"]}
                    required
                    errorMessages={[`Không được để trống`]}>
                    {product.results.map((item, key) => {
                      return (
                        <MenuItem key={key} value={item.Id}>
                          {item.Name}
                        </MenuItem>
                      );
                    })}
                  </SelectValidator>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Mã bưu gửi"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="Package_text__c"
                    value={this.state.ticket.Package_text__c}
                    validators={["required"]}
                    required
                    errorMessages={[`Không được để trống`]}
                  />

                  <SelectValidator
                    id="outlined-full-width"
                    margin="normal"
                    select
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu,
                        shrink: true,
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Phạm vi gửi"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    value={this.state.ticket.Location_Type__c}
                    name="Location_Type__c"
                    validators={["required"]}
                    required
                    errorMessages={[`Không được để trống`]}>
                    <MenuItem key="Trong nước" value="Trong nước">
                      Trong nước
                    </MenuItem>

                    <MenuItem key="Quốc tế" value="Quốc tế">
                      Quốc tế
                    </MenuItem>
                  </SelectValidator>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Chủ đề"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="Subject"
                    value={this.state.ticket.Subject}
                    validators={["required"]}
                    required
                    errorMessages={[`Không được để trống`]}
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Mô tả"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="Description"
                    value={this.state.ticket.Description}
                    multiline
                    rows={5}
                    validators={["required"]}
                    required
                    errorMessages={[`Không được để trống`]}
                  />
                </Grid>
                <Grid item md={6} style={{ paddingLeft: 10 }}>
                  <Typography>
                    Loại HS trường hợp: Tư vấn, hỗ trợ dịch vụ
                  </Typography>
                  <SelectValidator
                    id="outlined-full-width"
                    margin="normal"
                    select
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu,
                        shrink: true,
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Nhóm dịch vụ"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    value={this.state.ticket.Nhom_dich_vu__c}
                    name="Nhom_dich_vu__c"
                    validators={["required"]}
                    required
                    errorMessages={[`Không được để trống`]}>
                    {select.nhom_dich_vu.map((item) => {
                      return (
                        <MenuItem key={item.name} value={item.name}>
                          {item.name}
                        </MenuItem>
                      );
                    })}
                  </SelectValidator>
                  <SelectValidator
                    id="outlined-full-width"
                    margin="normal"
                    select
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu,
                        shrink: true,
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Nội dung hỗ trợ"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    value={this.state.ticket.Noi_dung_ho_tro__c}
                    name="Noi_dung_ho_tro__c"
                    validators={["required"]}
                    required
                    errorMessages={[`Không được để trống`]}>
                    {select.noi_dung_ho_tro.map((item) => {
                      return (
                        <MenuItem key={item.name} value={item.name}>
                          {item.name}
                        </MenuItem>
                      );
                    })}
                  </SelectValidator>

                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Mã khách hàng di sản"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="Ma_khach_hang__c"
                    value={this.state.ticket.Ma_khach_hang__c}
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Pháp nhân"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="Pha_p_nh_n__c"
                    value={this.state.ticket.Pha_p_nh_n__c}
                  />
                </Grid>
              </Grid>
              <Divider />
              <Typography
                style={{
                  backgroundColor: "#d3d4d9",
                  padding: "5px 15px",
                  fontSize: 18,
                }}>
                Thông tin liên hệ
              </Typography>
              <Grid container>
                <Grid item md={6} style={{ paddingRight: 10 }}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Địa chỉ chi tiết người liên hệ"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="Contact_address__c"
                    value={this.state.ticket.Contact_address__c}
                    multiline
                    rows={5}
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Phường xã liên hệ"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="Contact_commune__r"
                    value={this.state.ticket.Contact_commune__r}
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Quận huyện người liên hệ"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="Contact_district__r"
                    value={this.state.ticket.Contact_district__r}
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Tỉnh thành người liên hệ"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="Contact_province__r"
                    value={this.state.ticket.Contact_province__r}
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Quốc gia người liên hệ"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="Contact_nation__r"
                    value={this.state.ticket.Contact_nation__r}
                  />
                </Grid>
                <Grid item md={6} style={{ paddingLeft: 10 }}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Tên người khiếu nại"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="SuppliedName"
                    value={
                      loadingInfo == true
                        ? infoCustomer.name !== ""
                          ? infoCustomer.name
                          : this.state.ticket.SuppliedName
                        : this.state.ticket.SuppliedName
                    }
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Số điện thoại"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeTicket}
                    name="SuppliedPhone"
                    value={` ${
                      loadingInfo == true
                        ? infoCustomer.phone !== ""
                          ? infoCustomer.phone
                          : this.props.listActiveCall[0]
                          ? this.props.listActiveCall[0].from
                          : this.props.logInboundOutbound.length != 0
                          ? logInboundOutbound[0].numberFrom
                          : this.state.ticket.SuppliedPhone
                        : this.state.ticket.SuppliedPhone
                    }`}
                  />
                  {/* <TextValidator
                                id="outlined-full-width"
                                margin="normal"
                                label="Email"
                                variant="outlined"
                                className={classes.input}
                                onChange={this.handleChangeTicket}
                                name="SuppliedEmail"
                                value={loadingInfo == true ? infoCustomer.email !== '' ? infoCustomer.email : this.state.ticket.SuppliedEmail : this.state.ticket.SuppliedEmail}
                                type="email"
                            /> */}
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Công ty"
                    variant="outlined"
                    className={classes.input}
                    // onChange={this.handleChangeTicket}
                    // name="Contact_nation__r"
                    // value={this.state.ticket.Contact_nation__r}
                  />
                </Grid>
              </Grid>
              <Divider />
              <Typography
                style={{
                  backgroundColor: "#bbbcc4",
                  padding: "5px 15px",
                  fontSize: 18,
                }}>
                Thông tin bổ sung
              </Typography>
              <SelectValidator
                id="outlined-full-width"
                margin="normal"
                select
                SelectProps={{
                  MenuProps: {
                    className: classes.menu,
                    shrink: true,
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                label="Trạng thái"
                variant="outlined"
                className={classes.input}
                onChange={this.handleChangeTicket}
                value={this.state.ticket.Status}
                name="Status"
                validators={["required"]}
                required
                errorMessages={[`Không được để trống`]}>
                <MenuItem key="Mới tạo" value="Mới tạo">
                  Mới tạo
                </MenuItem>
                <MenuItem key="Đã tiếp nhận" value="Đã tiếp nhận">
                  Đã tiếp nhận
                </MenuItem>
                <MenuItem key="Đang xử lí" value="Đang xử lí">
                  Đang xử lí
                </MenuItem>
                <MenuItem key="Đã có kết quả" value="Đã có kết quả">
                  Đã có kết quả
                </MenuItem>
                <MenuItem key="Đã hoàn thành" value="Đã hoàn thành">
                  Đã hoàn thành
                </MenuItem>
                <MenuItem key="Hủy" value="Hủy">
                  Hủy
                </MenuItem>
                <MenuItem key="Mở lại" value="Mở lại">
                  Mở lại
                </MenuItem>
              </SelectValidator>
              <SelectValidator
                id="outlined-full-width"
                margin="normal"
                select
                SelectProps={{
                  MenuProps: {
                    className: classes.menu,
                    shrink: true,
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                label="Nguồn gốc của TH"
                variant="outlined"
                className={classes.input}
                onChange={this.handleChangeTicket}
                value={this.state.ticket.Origin}
                name="Origin"
                validators={["required"]}
                required
                errorMessages={[`Không được để trống`]}>
                {select.origin.map((item) => {
                  return (
                    <MenuItem key={item.name} value={item.name}>
                      {item.name}
                    </MenuItem>
                  );
                })}
              </SelectValidator>
              <SelectValidator
                id="outlined-full-width"
                margin="normal"
                select
                SelectProps={{
                  MenuProps: {
                    className: classes.menu,
                    shrink: true,
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                label="Mức độ ưu tiên"
                variant="outlined"
                className={classes.input}
                onChange={this.handleChangeTicket}
                value={this.state.ticket.Priority}
                name="Priority"
                validators={["required"]}
                required
                errorMessages={[`Không được để trống`]}>
                <MenuItem key="Cao" value="Cao">
                  Cao
                </MenuItem>
                <MenuItem key="Trung bình" value="Trung bình">
                  Trung bình
                </MenuItem>
                <MenuItem key="Thấp" value="Thấp">
                  Thấp
                </MenuItem>
              </SelectValidator>
            </MuiPickersUtilsProvider>
            <DialogActions>
              <Button
                onClick={() =>
                  this.setState({
                    openDialogTicket: false,
                    optionTicket: false,
                  })
                }
                color="secondary"
                className={classes.button}>
                Hủy
              </Button>

              <Button
                type="submit"
                variant="contained"
                color="primary"
                className={classes.button}>
                Lưu
              </Button>
            </DialogActions>
          </React.Fragment>
        );
      }

      default:
        break;
    }
  };

  handleCreateTicket = () => {
    const { idTicket, ticket, ticketType, logInboundOutbound } = this.state;
    const { initStatus } = this.props;
    let newTicket = {};
    const _ticketType = this.props.ticketType.find(
      (item) => item.refId === ticketType
    );
    if (_ticketType) {
      newTicket["Type"] = _ticketType.name;
    }
    if (initStatus) {
      if (initStatus.agentStatus) {
        if (initStatus.agentStatus.attributes) {
          newTicket["Employee__c"] = initStatus.agentStatus.attributes.Employee
            ? initStatus.agentStatus.attributes.Employee.id
            : "";
        }
      }
    }
    let _ticket = {};
    _ticket = { ...newTicket, ...ticket };
    // const { loadingInfo, infoCustomer } = this.props;
    this.props.addNewTicket(
      idTicket,
      { attributes: _ticket },
      this.state.phonenumber
    );
    setTimeout(
      function () {
        this.setState({
          openDialogTicket: false,
          ticket: [],
          optionTicket: false,
          isOpenTicket: false,
        });
      }.bind(this),
      300
    );
  };

  onChangeCommonNote = (e) => {
    const { formResult, codeParcel } = this.state;
    let array = JSON.parse(JSON.stringify(formResult));
    if (codeParcel) {
      array = array.map((item) => {
        if (item.code === codeParcel) {
          item.note = e.target.value;
        }
        return item;
      });
    } else {
      array[0].note = e.target.value;
    }
    this.setState({
      formResult: array,
    });
  };

  onDialogTicket = () => {
    this.setState(
      {
        isOpenTicket: !this.state.isOpenTicket,
      },
      () => {
        const { customer } = this.state;
        this.props.getTicketByNumber({
          phone: customer ? customer.phoneNumber : "",
        });
      }
    );
  };

  InfoCustomerDetail = () => {
    this.setState({
      isShowInfoCustomer: !this.state.isShowInfoCustomer,
    });
  };

  onPreviousCustomer = (e) => {
    e.preventDefault();
    const onClearFile = document.getElementById("fileName");
    if (onClearFile) {
      onClearFile.value = "";
    }
    const { listLogsCallTelesale } = this.props;
    const { idInteractivelog } = this.state;
    const listLogsCallTelesaleResult =
      typeof listLogsCallTelesale === "object"
        ? Object.keys(listLogsCallTelesale).map(
            (key) => listLogsCallTelesale[key]
          )
        : listLogsCallTelesale;

    this.setState({
      codeParcel: null,
    });

    let position = 0;

    if (this.getPosition(idInteractivelog, listLogsCallTelesaleResult) !== 0) {
      // Vị trí hiện tại khác vị trí đầu tiên
      position =
        this.getPosition(idInteractivelog, listLogsCallTelesaleResult) - 1;
    }
    // this.props.updateForm(idInteractivelog, { formResult: formResult }, null, customer.stageId);
    this.handleEdit(listLogsCallTelesaleResult[position], true);
    this.setState({ pageParcel: 0, totalParcel: 5 });
    let element = document.getElementById("form-campaign");
    if (element) {
      element.scrollIntoView();
    }
    const elementSurvey = document.getElementById("form-survey");
    if (elementSurvey) {
      elementSurvey.scrollTop = 0;
    }
  };

  getPosition = (id = null, array = []) => {
    let position = null;
    for (let i = 0; i < array.length; i++) {
      if (id + "" === array[i].id + "") {
        position = i;
      }
    }
    this.setState({
      position,
    });
    return position;
  };

  onSaveFormAndTicket = async (type) => {
    const {
      isValidTicket,
      idInteractivelog,
      formResult,
      customer,
      codeParcel,
      infoTicket,
      isValidTicketPacel,
    } = this.state;
    const { initStatus, agentStatus, infoCustomer } = this.props;

    let newTicket = {};
    if (
      initStatus &&
      initStatus.agentStatus &&
      initStatus.agentStatus.attributes &&
      initStatus.agentStatus.attributes.Employee &&
      initStatus.agentStatus.attributes.Employee.id
    ) {
      newTicket["Employee__c"] = initStatus.agentStatus.attributes.Employee.id;
    }
    let _ticket = {};
    let _lead = {};

    let Description = this.state.Description.split("|");

    _ticket = {
      ...newTicket,
      AccountId: infoCustomer.accountId ? infoCustomer.accountId : "",
      Description:
        type && type === "package"
          ? `${Description[0]}|Ticket được tạo từ bưu gửi ${codeParcel}`
          : this.state.Description,
      OwnerId: this.state.OwnerId ? this.state.OwnerId : "",
      Package_text__c: "",
      Priority: "",
      Service__c: "",
      Status: "Đã tiếp nhận",
      Subject:
        this.state.campaignService &&
        this.state.campaign &&
        this.state.campaignService.code &&
        this.state.campaign.name
          ? this.state.campaignService.code + " - " + this.state.campaign.name
          : infoTicket && infoTicket.attributes && infoTicket.attributes.Subject
          ? infoTicket.attributes.Subject
          : "",
      SuppliedPhone:
        customer && customer.phoneNumber && customer.phoneNumber !== "undefined"
          ? customer.phoneNumber
          : "",
      SuppliedName:
        customer && customer.fullName && customer.fullName !== "undefined"
          ? customer.fullName
          : "",
      Type:
        this.state.campaignGroup && this.state.campaignGroup.name
          ? this.state.campaignGroup.name
          : infoTicket && infoTicket.attributes && infoTicket.attributes.Type
          ? infoTicket.attributes.Type
          : "",
    };
    _lead = {
      lead: {
        isLead: !!this.state.OwnerId,
        leadEmail:
          customer && customer.email && customer.email !== "undefined"
            ? customer.email
            : "",
        ...this.state.lead,
      },
      Employee_Name:
        agentStatus.attributes &&
        agentStatus.attributes.Employee &&
        agentStatus.attributes.Employee.name
          ? agentStatus.attributes.Employee.name
          : "",
      Product_Name: "",
      Pos_Name: this.state.Pos_Name ? this.state.Pos_Name : "",
      Owner_Name: "",
      accountName: infoCustomer.accountName ? infoCustomer.accountName : "",
      FileTicket: this.state.FileTicket,
      callId: this.state.CallResult ? this.state.CallResult.id : "",
      callName: this.state.CallResult ? this.state.CallResult.label : "",
      processId: this.state.ProcessResult ? this.state.ProcessResult.id : "",
      processName: this.state.ProcessResult
        ? this.state.ProcessResult.label
        : "",
      RequestDetail:
        type && type !== "package"
          ? this.state.RequestDetail
            ? this.state.RequestDetail
            : this.state.Description.split("|")[2]
          : "",
      packageId: codeParcel,
    };

    let _atr = { attributes: _ticket };

    let updateForm = null;
    updateForm = await put(`/mini-crm/interactive-log/${idInteractivelog}`, {
      formResult: formResult,
      stageId: customer.stageId,
    });
    // await this.props.updateFormInteractiveLog(updateForm.data);

    const promiseForm = new Promise((resolve, reject) => {
      if (updateForm !== null && updateForm) {
        resolve(updateForm);
      } else {
        reject();
      }
    });

    // this.props.updateForm(idInteractivelog, {formResult: formResult}, null, customer.stageId);

    _atr = { ..._atr, customFields: _lead };

    promiseForm
      .then((response) => {
        if (codeParcel) {
          if (infoTicket || isValidTicketPacel) {
            this.props.updateTicket(
              infoTicket ? infoTicket.id : this.props.newIdTicket,
              "outbound",
              _atr,
              this.state.phonenumber,
              "outbound",
              this.state.idInteractivelog,
              this.state.arrayTicket,
              response.data
            );
          } else {
            this.setState({
              isValidTicketPacel: true,
            });
            this.props.addNewTicket(
              "outbound",
              _atr,
              this.state.phonenumber,
              "outbound",
              this.state.idInteractivelog,
              response.data
            );
          }
        } else {
          if (infoTicket || isValidTicket) {
            this.props.updateTicket(
              infoTicket ? infoTicket.id : this.props.newIdTicket,
              "outbound",
              _atr,
              this.state.phonenumber,
              "outbound",
              this.state.idInteractivelog,
              response.data
            );
          } else {
            this.setState({
              isValidTicket: true,
            });
            this.props.addNewTicket(
              "outbound",
              _atr,
              this.state.phonenumber,
              "outbound",
              this.state.idInteractivelog,
              response.data
            );
          }
        }
      })
      .catch((error) => console.log(error));
  };

  handleSearchTicket = (text, type) => {
    if (type === "listCall") {
      this.setState({
        listCall: filterCustomers(listCall, text),
      });
    }

    if (type === "listResult") {
      this.setState({
        listResult: filterCustomers(listResult, text),
      });
    }
  };

  handleSearchLeadOffice = (text) => {
    const { findLead } = this.props;
    findLead(text, 10);
  };

  onChangeUserLead = (e) => {
    const { lead } = this.state;
    if (e) {
      lead["pos"] = e.id;
      this.setState({
        lead,
        Pos_Name: e.name,
        OwnerId: e.id,
      });
    } else {
      lead["pos"] = "";
      this.setState({
        lead,
        Pos_Name: "",
        OwnerId: "",
      });
    }
  };

  upload = (e) => {
    e.preventDefault();
    const { token } = this.state;
    const data = new FormData();
    data.append("file", e.target.files[0]);
    axios
      .post(
        `${API_PROTOCOL}://${API_HOST}/media-mgt/container/mini-crm/upload`,
        data,
        {
          headers: {
            Authorization: token,
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((res) => {
        this.setState({
          FileTicket: res.data.result.files.file[0].name,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  render() {
    const { classes, listStage, getTicket, lead } = this.props;
    const {
      filters,
      customer,
      position,
      formResult,
      codeParcel,
      packages,
      infoTicket,
    } = this.state;
    const listStageResult =
      typeof listStage === "object"
        ? Object.keys(listStage).map((key) => listStage[key])
        : listStage;
    const { listLogsCallTelesale, coutLogsCallTelesale, listCampaign } =
      this.props;
    const listLogsCallTelesaleResult =
      typeof listLogsCallTelesale === "object"
        ? Object.keys(listLogsCallTelesale).map(
            (key) => listLogsCallTelesale[key]
          )
        : listLogsCallTelesale;
    const listCampaignResult =
      typeof listCampaign === "object"
        ? Object.keys(listCampaign).map((key) => listCampaign[key])
        : listCampaign;
    const common_note = codeParcel
      ? formResult.filter((item) => item.code === codeParcel)[0] &&
        formResult.filter((item) => item.code === codeParcel)[0].result
        ? formResult.filter((item) => item.code === codeParcel)[0].note
        : ""
      : formResult.length && formResult[0].note
      ? formResult[0].note
      : "";
    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmitSearch}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container spacing={24}>
                      <Grid item md={3}>
                        <SelectValidator
                          id="outlined-full-width"
                          margin="normal"
                          label="Tên chiến dịch"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleSearch}
                          value={filters.where.campaignId}
                          name="campaignId"
                          InputLabelProps={{
                            shrink: true,
                          }}>
                          <MenuItem>
                            <em>Tất cả</em>
                          </MenuItem>
                          {listCampaignResult
                            ? listCampaignResult.map((item, key) => {
                                return (
                                  <MenuItem key={key} value={item.id}>
                                    {item.name}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </SelectValidator>
                      </Grid>
                      <Grid item md={3}>
                        <SelectValidator
                          id="outlined-full-width"
                          margin="normal"
                          label="Trạng thái khách hàng"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleSearch}
                          value={filters.where.stageId}
                          name="stageId"
                          InputLabelProps={{
                            shrink: true,
                          }}>
                          <MenuItem>
                            <em>Tất cả</em>
                          </MenuItem>
                          {listStageResult
                            ? listStageResult.map((item, key) => {
                                return (
                                  <MenuItem key={key} value={item.id}>
                                    {item.name}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </SelectValidator>
                      </Grid>
                      <Grid
                        item
                        md={3}
                        style={{ alignItems: "center", display: "flex" }}>
                        <Tooltip title="Tìm kiếm" disableFocusListener>
                          <Fab
                            color="primary"
                            aria-label="Search"
                            className={classes.fab}
                            type="submit">
                            <Search />
                          </Fab>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </MuiPickersUtilsProvider>
                </FormGroup>
              </FormControl>
            </CardContent>
          </Card>
        </ValidatorForm>
        <TableData
          {...this.props}
          nameTable={`Danh sách khách hàng cần gọi`}
          items={listLogsCallTelesaleResult}
          rowsPerPage={filters.pageSize}
          count={coutLogsCallTelesale ? coutLogsCallTelesale : 0}
          page={
            filters.pageSize === 20
              ? filters.page / 20
              : filters.pageSize === 40
              ? filters.page / 40
              : filters.pageSize === 60
              ? filters.page / 60
              : filters.pageSize === 80
              ? filters.page / 80
              : filters.page / 100
          }
          rowItems={this.listCollumns}
          handleView={this.openModalView}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          handleEdit={this.handleEdit}
        />
        <Dialog open={this.props.loading} title={<CircularProgress />} />
        <DialogMaterial
          // open={codeParcel ? this.state.modalWorking : this.state.modalWorking && this.props.isShowModal === false}
          open={this.state.modalWorking}
          scroll="paper"
          aria-labelledby="scroll-dialog-title"
          fullScreen>
          <div id="form-campaign" />
          <AppBar className={classes.appBar} style={{ color: "#fff" }}>
            <Toolbar>
              <IconButton
                color="inherit"
                onClick={this.handleClose}
                aria-label="Close">
                <Icon>close</Icon>
              </IconButton>
              <Typography variant="h6" color="inherit" className={classes.flex}>
                Giao diện làm việc
              </Typography>
              {this.props.listActiveCall[0] ? (
                this.props.listActiveCall[0].type == "outbound" ? (
                  <Typography
                    variant="h6"
                    style={{ color: "red" }}
                    className={classes.flex}>
                    Đang gọi:{" "}
                    {datetimeHelper.secondToHHMMSS(
                      this.props.listActiveCall[0].bridgedDuration
                    )}
                  </Typography>
                ) : (
                  <React.Fragment />
                )
              ) : (
                <React.Fragment />
              )}
              <Fab
                aria-label="add"
                className={classes.fab}
                size="small"
                style={{ backgroundColor: "#4caf50" }}
                onClick={this.callNumber}>
                <Icon>phone</Icon>
              </Fab>
            </Toolbar>
          </AppBar>
          <div style={{ backgroundColor: "#f5f5f5" }}>
            <Grid container spacing={24} style={{ marginTop: 10 }}>
              <Grid item xs={12}>
                <div
                  className={classes.root}
                  elevation={1}
                  style={{ backgroundColor: "#fff", marginBottom: "20px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}>
                    <Typography
                      variant="h5"
                      component="h3"
                      className={classes.typo}>
                      Thông tin khách hàng
                    </Typography>
                  </div>
                  <Divider style={{ marginTop: 5, marginBottom: 10 }} />
                  <ValidatorForm
                    ref="form"
                    onSubmit={this.handleSaveCustomer}
                    onError={(errors) => console.log(errors)}
                    className={classes.form}>
                    <React.Fragment>
                      <Grid container xs={12} spacing={16}>
                        <Grid item xs={12} sm={12} md={6} xl={6} lg={6}>
                          <Typography
                            component="p"
                            style={{
                              fontWeight: "bold",
                              alignItems: "center",
                              marginBottom: 10,
                              display: "flex",
                              whiteSpace: "nowrap",
                            }}>
                            Số điện thoại:{" "}
                            <Typography
                              component="p"
                              style={{
                                color: `red`,
                                marginLeft: 10,
                                fontWeight: "bold",
                                fontSize: 18,
                              }}>
                              {" "}
                              {` ${
                                customer != null ? customer.phoneNumber : ""
                              }`}{" "}
                            </Typography>
                          </Typography>
                          <Typography
                            component="p"
                            style={{
                              fontWeight: "bold",
                              alignItems: "center",
                              marginBottom: 10,
                              display: "flex",
                              whiteSpace: "nowrap",
                            }}>
                            {/* Họ tên:  <Typography component="p" style={{ marginLeft: 10 }}> {` ${loadingInfo == true ? infoCustomer.name : ''}`}</Typography> */}
                            Họ tên:{" "}
                            <TextValidator
                              className={classes.input}
                              onChange={this.handleChangeCustomer("fullName")}
                              name="name"
                              inputProps={{
                                "aria-label": "Description",
                              }}
                              value={`${
                                customer != null ? customer.fullName : ""
                              }`}
                              // validators={["required"]}
                              // required
                              // errorMessages={[`Không được để trống`]}
                            />
                          </Typography>
                          <Typography
                            component="p"
                            style={{
                              fontWeight: "bold",
                              alignItems: "center",
                              marginBottom: 10,
                              display: "flex",
                              whiteSpace: "nowrap",
                            }}>
                            {/* Email:  <Typography component="p" style={{ marginLeft: 10 }}> {`${loadingInfo == true ? infoCustomer.email : ''}`}</Typography> */}
                            Email:{" "}
                            <TextValidator
                              className={classes.input}
                              onChange={this.handleChangeCustomer("email")}
                              name="email"
                              inputProps={{
                                "aria-label": "Description",
                              }}
                              validators={[
                                'matchRegexp:^(([^<>()\\[\\]\\.,;:\\s@\\"]+(\\.[^<>()\\[\\]\\.,;:\\s@\\"]+)*)|(\\".+\\"))@(([^<>()[\\]\\.,;:\\s@\\"]+\\.)+[^<>()[\\]\\.,;:\\s@\\"]{2,})$',
                              ]}
                              errorMessages={["Email không đúng định dạng"]}
                              value={`${
                                customer != null ? customer.email : ""
                              }`}
                            />
                          </Typography>
                          <Typography
                            component="p"
                            style={{
                              fontWeight: "bold",
                              alignItems: "center",
                              marginBottom: 15,
                              display: "flex",
                              whiteSpace: "nowrap",
                            }}>
                            {/* Địa chỉ liên hệ:  <Typography component="p" style={{ marginLeft: 10 }}> {`${loadingInfo == true ? infoCustomer.address : ''}`}</Typography> */}
                            Địa chỉ liên hệ:{" "}
                            <TextValidator
                              className={classes.input}
                              onChange={this.handleChangeCustomer("address")}
                              name="address"
                              inputProps={{
                                "aria-label": "Description",
                              }}
                              value={`${
                                customer != null ? customer.address : ""
                              }`}
                              // validators={["required"]}
                              // required
                              // errorMessages={[`Không được để trống`]}
                            />
                          </Typography>
                          <Typography
                            component="p"
                            style={{
                              fontWeight: "bold",
                              alignItems: "center",
                              marginBottom: 15,
                              display: "flex",
                              whiteSpace: "nowrap",
                            }}>
                            {/* Địa chỉ liên hệ:  <Typography component="p" style={{ marginLeft: 10 }}> {`${loadingInfo == true ? infoCustomer.address : ''}`}</Typography> */}
                            Trạng thái khách hàng:{" "}
                            <TextValidator
                              className={classes.input}
                              onChange={this.handleChangeCustomer("stageId")}
                              name="stageId"
                              inputProps={{
                                "aria-label": "Description",
                              }}
                              value={customer != null ? customer.stageId : ""}
                              // validators={["required"]}
                              // required
                              // errorMessages={[`Không được để trống`]}
                              select>
                              {listStageResult
                                ? listStageResult.map((item, key) => {
                                    return (
                                      <MenuItem key={key} value={item.id}>
                                        {item.name}
                                      </MenuItem>
                                    );
                                  })
                                : null}
                            </TextValidator>
                          </Typography>
                          <Typography
                            component="p"
                            style={{
                              fontWeight: "bold",
                              alignItems: "center",
                              marginBottom: 15,
                              display: "flex",
                              whiteSpace: "nowrap",
                            }}>
                            Ghi chú:{" "}
                            <TextValidator
                              className={classes.input}
                              // onChange={this.handleChangeCustomer("note")}
                              onChange={(e) => {
                                const text = e.target.value
                                  ? e.target.value
                                  : "";
                                this.setState({
                                  note_interactivelog: text,
                                });
                              }}
                              name="address"
                              inputProps={{
                                "aria-label": "Ghi chú",
                              }}
                              value={
                                this.state.note_interactivelog
                                  ? this.state.note_interactivelog
                                  : ""
                              }
                              // validators={["required"]}
                              // required
                              // errorMessages={[`Không được để trống`]}
                            />
                          </Typography>
                          <Typography
                            component="p"
                            style={{
                              fontWeight: "bold",
                              alignItems: "center",
                              display: "flex",
                              whiteSpace: "nowrap",
                            }}>
                            Thời gian gọi:{" "}
                            <Typography
                              component="p"
                              style={{ marginLeft: 10 }}>
                              {" "}
                              {` ${
                                this.props.listActiveCall[0]
                                  ? datetimeHelper.secondToHHMMSS(
                                      this.props.listActiveCall[0]
                                        .bridgedDuration
                                    )
                                  : "00:00:00"
                              }`}
                            </Typography>
                          </Typography>
                          <Typography
                            component="p"
                            style={{
                              fontWeight: "bold",
                              alignItems: "center",
                              display: "flex",
                              whiteSpace: "nowrap",
                              marginTop: "20px",
                            }}>
                            Tình trạng cuộc gọi:{" "}
                            <Typography
                              component="p"
                              style={{
                                color: `red`,
                                marginLeft: 10,
                                fontWeight: "bold",
                                fontSize: 18,
                              }}>{`${
                              this.props.listActiveCall[0]
                                ? this.props.listActiveCall[0].status
                                : ""
                            }`}</Typography>
                          </Typography>
                          <DialogActions>
                            <Button
                              variant="contained"
                              size="small"
                              style={{ marginTop: 5 }}
                              color="primary"
                              className={classes.button}
                              onClick={() => {
                                this.setState({
                                  isOpenCreateTicket:
                                    !this.state.isOpenCreateTicket,
                                });
                              }}>
                              Tạo ticket
                            </Button>
                            <Button
                              variant="contained"
                              size="small"
                              style={{ marginTop: 5 }}
                              color="primary"
                              className={classes.button}
                              onClick={this.onDialogTicket}>
                              Thông tin ticket
                            </Button>

                            {/*<Button variant="contained" size="small" style={{ marginTop: 5 }} color="primary" className={classes.button} onClick={this.InfoCustomerDetail}>*/}
                            {/*    Thông tin chi tiết*/}
                            {/*</Button>*/}
                            <Button
                              type="submit"
                              variant="contained"
                              size="small"
                              style={{ marginTop: 5 }}
                              color="primary"
                              className={classes.button}>
                              Lưu thông tin
                            </Button>
                          </DialogActions>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} xl={6} lg={6}>
                          <div style={{ overflowY: "scroll", height: "370px" }}>
                            {customer && customer.attributes
                              ? Object.keys(customer.attributes).map(
                                  (item, index) => {
                                    return (
                                      <Grid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={12}
                                        lg={12}
                                        xl={12}
                                        key={index}
                                        style={{ padding: 5 }}>
                                        <TextField
                                          id="outlined-full-width"
                                          margin="normal"
                                          label={item}
                                          variant="outlined"
                                          fullWidth={true}
                                          className={classes.input}
                                          value={customer.attributes[item]}
                                          disabled
                                          InputProps={{
                                            className: classes.input,
                                          }}
                                        />
                                      </Grid>
                                    );
                                  }
                                )
                              : []}
                          </div>
                        </Grid>
                      </Grid>
                    </React.Fragment>
                  </ValidatorForm>
                </div>
              </Grid>
            </Grid>
          </div>
          <Paper
            className={classes.root}
            style={{ marginTop: 10 }}
            elevation={1}>
            {/*Check xem co bưu gửi hay không?*/}
            {packages ? (
              <ValidatorForm
                ref="form"
                onSubmit={(e) => this.handleChangeForm(e, "save")}
                onError={(errors) => console.log(errors)}
                className={classes.form}>
                <Typography
                  variant="h5"
                  component="h3"
                  className={classes.typo}>
                  Telesale khảo sát chất lượng
                </Typography>
                <Divider />
                <Grid container spacing={16}>
                  <Grid item xs={12} sm={12} md={6} xl={6} lg={6}>
                    <TableData
                      nameTable={`Danh sách bưu gửi`}
                      items={
                        this.state.customer && this.state.customer.packages
                          ? this.state.customer.packages
                              .filter((item) => item.code)
                              .slice(
                                this.state.pageParcel * 5,
                                (this.state.pageParcel + 1) * 5
                              )
                              .map((item, index) => {
                                item.no = index + 1 + this.state.pageParcel * 5;
                                item.codeParcel = item.code;
                                return item;
                              })
                          : []
                      }
                      count={
                        this.state.customer && this.state.customer.packages
                          ? this.state.customer.packages.filter(
                              (item) => item.code
                            ).length
                          : 0
                      }
                      page={this.state.pageParcel}
                      rowItems={listCollumnsParcel}
                      handleChangePage={this.handleChangePageParcel}
                      handleSelectParcel={this.handleSelectParcel}
                      selectedParcel={this.state.codeParcel}
                      parcel={true}
                      rowsPerPage={5}
                      rowSelectData={[5]}
                      layout={6}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} xl={6} lg={6}>
                    <div
                      className="scrollLayout"
                      id="form-survey"
                      style={{
                        overflowY: "scroll",
                        height: "450px",
                        overflowX: "hidden",
                      }}>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <FormControl
                          style={{
                            display: this.renderQuestion() ? "flex" : "none",
                            marginBottom: 15,
                          }}>
                          {this.renderQuestion()}
                          <TextValidator
                            id="outlined-full-width"
                            margin="normal"
                            label="Ghi chú chung"
                            variant="outlined"
                            className={classes.input}
                            onChange={this.onChangeCommonNote}
                            value={common_note ? common_note : ""}
                            name="note"
                            multiline
                            rows={3}
                          />
                        </FormControl>
                        <DialogActions
                          style={{
                            display: this.renderQuestion() ? "flex" : "none",
                          }}>
                          <Button
                            variant="contained"
                            size="small"
                            color="primary"
                            className={classes.button}
                            onClick={() => this.onSaveFormAndTicket("package")}>
                            Lưu thông tin phiếu khảo sát
                          </Button>
                        </DialogActions>
                      </MuiPickersUtilsProvider>
                    </div>
                  </Grid>
                </Grid>
              </ValidatorForm>
            ) : (
              <ValidatorForm
                ref="form"
                onSubmit={(e) => this.handleChangeForm(e, "save")}
                onError={(errors) => console.log(errors)}
                className={classes.form}>
                {this.renderQuestion() && (
                  <>
                    <Typography
                      variant="h5"
                      component="h3"
                      className={classes.typo}>
                      Telesale khảo sát chất lượng
                    </Typography>
                    <Divider />
                  </>
                )}

                <Grid container>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <FormControl
                      style={{
                        display: packages ? "none" : "flex",
                        marginBottom: 15,
                        width: "100%",
                      }}>
                      {this.renderQuestion()}
                      <TextValidator
                        id="outlined-full-width"
                        margin="normal"
                        label="Ghi chú chung"
                        variant="outlined"
                        className={classes.input}
                        onChange={this.onChangeCommonNote}
                        value={common_note ? common_note : ""}
                        name="note"
                        multiline
                        rows={3}
                      />
                    </FormControl>
                  </MuiPickersUtilsProvider>
                </Grid>
                <Typography
                  variant="h5"
                  component="h3"
                  className={classes.typo}>
                  Chuyển ticket và khách hàng tiềm năng
                </Typography>
                <Divider />
                <Grid container>
                  {/*<Typography variant="h5" component="h3" className={classes.typo}>*/}
                  {/*    Thông tin Ticket và Lead*/}
                  {/*</Typography>*/}
                  {/*<Divider/>*/}
                  <Grid container xs={12} spacing={24}>
                    <Grid item xs={6} sm={6} md={6} xl={6} lg={6}>
                      <Typography
                        variant="h6"
                        component="h6"
                        className={classes.typo}>
                        Thông tin khách hàng
                      </Typography>
                      <Grid item xs={12} sm={12} md={12} xl={12} lg={12}>
                        <SelectAutoComplete
                          label={"Kết quả khách hàng nghe máy"}
                          className={classes.inputTicket}
                          data={
                            this.state.listCall.length > 0
                              ? this.state.listCall
                              : listCall
                          }
                          value={
                            this.state.CallResult
                              ? this.state.CallResult.id
                              : ""
                          }
                          onSearch={debounce(
                            (text) => this.handleSearchTicket(text, "listCall"),
                            300
                          )}
                          onChange={(item) => {
                            this.setState(
                              {
                                CallResult: item ? item : null,
                              },
                              () => {
                                if (this.state.CallResult) {
                                  let Description =
                                    this.state.Description.split("|");
                                  Description[1] = this.state.CallResult.label;
                                  this.setState({
                                    Description: Description.join("|"),
                                  });
                                }
                              }
                            );
                          }}
                          onClear={true}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} xl={12} lg={12}>
                        <SelectAutoComplete
                          label={"Kết quả xử lý"}
                          className={classes.inputTicket}
                          data={
                            this.state.listResult.length > 0
                              ? this.state.listResult
                              : listResult
                          }
                          value={
                            this.state.ProcessResult
                              ? this.state.ProcessResult.id
                              : ""
                          }
                          onSearch={debounce(
                            (text) =>
                              this.handleSearchTicket(text, "listResult"),
                            300
                          )}
                          onChange={(item) => {
                            this.setState({
                              ProcessResult: item ? item : null,
                            });
                          }}
                          onClear={true}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} xl={12} lg={12}>
                        <TextField
                          id="outlined-multiline-static"
                          label="Chi tiết yêu cầu"
                          className={classes.inputTicket}
                          multiline
                          value={
                            this.state.RequestDetail
                              ? this.state.RequestDetail
                              : ""
                          }
                          rows={4}
                          onChange={(e) => {
                            this.setState(
                              {
                                RequestDetail:
                                  e && e.target.value ? e.target.value : "",
                              },
                              () => {
                                let Description =
                                  this.state.Description.split("|");
                                Description[2] = this.state.RequestDetail;

                                this.setState({
                                  Description: Description.join("|"),
                                });
                              }
                            );
                          }}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        xl={12}
                        lg={12}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          paddingTop: 10,
                          paddingBottom: 10,
                        }}>
                        <Typography style={{ marginRight: 5 }}>
                          Đính kèm file
                        </Typography>
                        <CloudUpload />
                        <input
                          type="file"
                          name="fileName"
                          id="fileName"
                          style={{ marginLeft: 15 }}
                          // value={this.state.FileTicket}
                          onChange={this.upload}
                        />
                      </Grid>
                      <Typography
                        variant="h6"
                        component="h6"
                        className={classes.typo}>
                        Thông tin phản hồi của đơn vị hỗ trợ
                      </Typography>
                      <Grid item xs={12} sm={12} md={12} xl={12} lg={12}>
                        <TextField
                          id="outlined-multiline-static"
                          label="Nội dung đơn vị đã hỗ trợ"
                          className={classes.inputTicket}
                          variant="outlined"
                          value={
                            infoTicket &&
                            infoTicket.attributes &&
                            infoTicket.attributes.Comments__c
                              ? infoTicket.attributes.Comments__c
                              : ""
                          }
                          style={{ backgroundColor: "wheat" }}
                          disabled
                        />
                      </Grid>
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} xl={6} lg={6}>
                      <Typography
                        variant="h6"
                        component="h6"
                        className={classes.typo}>
                        Chuyển khách hàng tiềm năng
                      </Typography>
                      <Grid item xs={12} sm={12} md={12} xl={12} lg={12}>
                        <SelectAutoComplete
                          label={"Đơn vị nhận khách hàng tiềm năng"}
                          data={
                            lead &&
                            lead.length > 0 &&
                            lead.map((val) => {
                              return {
                                id: val.id,
                                label: val.name + " - " + val.id,
                                name: val.name,
                              };
                            })
                          }
                          className={classes.inputTicket}
                          value={
                            !this.props.isShowModal && this.state.OwnerId
                              ? this.state.OwnerId
                              : ""
                          }
                          required={false}
                          onSearch={debounce(this.handleSearchLeadOffice, 300)}
                          onChange={this.onChangeUserLead}
                          onClear={true}
                          loading={this.props.leadLoading}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </ValidatorForm>
            )}
            <Grid
              container
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "20px",
              }}>
              {position > 0 && (
                <Button
                  style={{ marginLeft: "10px" }}
                  variant="contained"
                  size="small"
                  color="primary"
                  className={classes.button}
                  onClick={this.onPreviousCustomer}>
                  Quay lại
                </Button>
              )}
              <Button
                style={{ marginLeft: "10px" }}
                variant="contained"
                size="small"
                color="primary"
                className={classes.button}
                onClick={(e) => this.handleChangeForm(e, "submit")}>
                Tiếp tục
              </Button>
              {!packages && (
                <Button
                  style={{ marginLeft: "10px" }}
                  variant="contained"
                  size="small"
                  color="primary"
                  className={classes.button}
                  onClick={this.onSaveFormAndTicket}>
                  Lưu thông tin phiếu khảo sát
                </Button>
              )}
            </Grid>
          </Paper>
        </DialogMaterial>
        <Dialog
          open={this.state.openDialogTicket}
          onClose={() => this.setState({ openDialogTicket: false })}
          title="Tạo ticket"
          maxWidth="xl"
          input={
            <ValidatorForm
              ref="form"
              onSubmit={this.handleCreateTicket}
              onError={(errors) => console.log(errors)}
              className={classes.form}>
              <SelectValidator
                id="outlined-full-width"
                margin="normal"
                select
                SelectProps={{
                  MenuProps: {
                    className: classes.menu,
                    shrink: true,
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                label="Loại ticket"
                variant="outlined"
                className={classes.input}
                onChange={this.handleSelectTicket("ticketType")}
                value={this.state.ticketType}
                style={{ width: 350 }}
                name="ticketType">
                {this.props.ticketType !== undefined ? (
                  this.props.ticketType.map((item, key) => {
                    return (
                      <MenuItem key={key} value={item.refId}>
                        {item.name}
                      </MenuItem>
                    );
                  })
                ) : (
                  <React.Fragment />
                )}
              </SelectValidator>
            </ValidatorForm>
          }
        />
        <Dialog
          open={this.state.isOpenTicket}
          onClose={() => this.setState({ isOpenTicket: false })}
          title="Thông tin ticket"
          buttonExit={true}
          fullwidth={true}
          input={
            <Paper
              className={classes.root}
              elevation={1}
              style={{ overflow: "hidden" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}>
                <Typography
                  variant="h5"
                  component="h3"
                  className={classes.typo}>
                  Lịch sử ticket
                </Typography>
                {/*<Fab*/}
                {/*    color="primary" aria-label="add"*/}
                {/*    className={classes.fab}*/}
                {/*    size="small"*/}
                {/*    onClick={() => this.setState({ openDialogTicket: true })}*/}
                {/*>*/}
                {/*    <Add className={classes.add} />*/}
                {/*</Fab>*/}
              </div>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell>Loại ticket</TableCell>
                    <TableCell>Loại yêu cầu</TableCell>
                    <TableCell>Trạng thái</TableCell>
                    <TableCell>Ưu tiên</TableCell>
                    <TableCell>Thời gian tạo</TableCell>
                    <TableCell>Xem</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.props.loadingTicket ? (
                    <div
                      style={{
                        position: "sticky",
                        transform: "translate(-50%, 10%)",
                        left: "50%",
                      }}>
                      <CircularProgress />
                    </div>
                  ) : (
                    getTicket &&
                    getTicket.length > 0 &&
                    getTicket.map((item, key) => {
                      return (
                        <TableRow key={key}>
                          <TableCell>
                            {(item && item.source !== "outbound") ||
                            (item && item.source && item.source === "") ||
                            (item && item.source && item.source === undefined)
                              ? "Ticket Inbound"
                              : "Ticket Outbound"}
                          </TableCell>
                          <TableCell>
                            {item && item.attributes && item.attributes.Type
                              ? item.attributes.Type
                              : ""}
                          </TableCell>
                          <TableCell>
                            {item.status ? item.status : ""}
                          </TableCell>
                          <TableCell>
                            {item.priority ? item.priority : ""}
                          </TableCell>
                          <TableCell>
                            {item.createdTime
                              ? datetimeHelper.toFormat(
                                  item.createdTime,
                                  "YYYY-MM-DD HH:mm:ss"
                                )
                              : ""}
                          </TableCell>
                          <TableCell>
                            <div>
                              <Fab
                                color="primary"
                                aria-label="add"
                                className={classes.fab}
                                size="small"
                                onClick={() => this.itemTicket(item)}>
                                <Visibility className={classes.add} />
                              </Fab>
                            </div>
                          </TableCell>
                        </TableRow>
                      );
                    })
                  )}
                </TableBody>
              </Table>
            </Paper>
          }
        />
        <Dialog
          open={this.state.optionTicket}
          onClose={() =>
            this.setState({ openDialogTicket: false, optionTicket: false })
          }
          title="Tạo ticket"
          maxWidth="xl"
          input={
            <ValidatorForm
              ref="form"
              onSubmit={this.handleCreateTicket}
              onError={(errors) => console.log(errors)}
              className={classes.form}>
              {this.renderTicket()}
            </ValidatorForm>
          }
        />
        <Dialog
          open={this.state.modalAction}
          maxWidth={"xl"}
          // title={`Xem thông tin ticket: ${
          //   this.state.itemTicket
          //     ? this.state.itemTicket.id
          //       ? this.state.itemTicket.ticketType.name
          //       : ""
          //     : null
          // }`}
          title={`Xem thông tin ticket`}
          input={
            <ValidatorForm
              ref="form"
              // onSubmit={this.handleAction}
              onError={(errors) => console.log(errors)}
              className={classes.form}>
              <Typography
                style={{
                  backgroundColor: "#d3d4d9",
                  padding: "5px 15px",
                  fontSize: 18,
                }}>
                Thông tin ticket
              </Typography>
              <Grid container={true} spacing={24}>
                <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Loại yêu cầu"
                    variant="outlined"
                    className={classes.input}
                    name="type"
                    value={
                      this.state.itemTicket &&
                      this.state.itemTicket.attributes &&
                      this.state.itemTicket.attributes.Type
                        ? this.state.itemTicket.attributes.Type
                        : ""
                    }
                    required
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Mã ticket"
                    variant="outlined"
                    className={classes.input}
                    name="id"
                    value={
                      this.state.itemTicket
                        ? this.state.itemTicket.ticketNumber
                        : null
                    }
                    required
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Mức độ ưu tiên"
                    variant="outlined"
                    className={classes.input}
                    name="Priority"
                    value={
                      this.state.itemTicket
                        ? this.state.itemTicket.priority
                        : null
                    }
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Thời gian tạo"
                    variant="outlined"
                    className={classes.input}
                    name="createdAt"
                    value={
                      this.state.itemTicket
                        ? moment(
                            new Date(this.state.itemTicket.createdTime)
                          ).format("DD/MM/YYYY HH:mm")
                        : null
                    }
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Trạng thái"
                    variant="outlined"
                    className={classes.input}
                    name="status"
                    value={
                      this.state.itemTicket
                        ? this.state.itemTicket.status
                        : null
                    }
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
              </Grid>
              <Typography
                style={{
                  backgroundColor: "#d3d4d9",
                  padding: "5px 15px",
                  fontSize: 18,
                }}>
                Thông tin liên hệ
              </Typography>
              <Grid container={true} spacing={24}>
                <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Số điện thoại liên hệ"
                    variant="outlined"
                    className={classes.input}
                    name="SuppliedPhone"
                    value={
                      this.state.itemTicket && this.state.itemTicket.contact
                        ? this.state.itemTicket.contact.phone
                        : null
                    }
                    required
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Tên khách hàng (Account)"
                    variant="outlined"
                    className={classes.input}
                    name="AccountId"
                    value={
                      this.state.itemTicket && this.state.itemTicket.contact
                        ? this.state.itemTicket.contact.lastName
                        : null
                    }
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Tên người liên hệ (Contact)"
                    variant="outlined"
                    className={classes.input}
                    name="SuppliedName"
                    value={
                      this.state.itemTicket && this.state.itemTicket.attributes
                        ? this.state.itemTicket.attributes.SuppliedName
                        : null
                    }
                    required
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Nhân viên tiếp nhận và xử lý"
                    variant="outlined"
                    className={classes.input}
                    name="OwnerId"
                    value={
                      this.state.itemTicket &&
                      this.state.itemTicket.customFields
                        ? this.state.itemTicket.customFields.Employee_Name
                          ? this.state.itemTicket.customFields.Employee_Name
                          : null
                        : null
                    }
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Email người liên hệ"
                    variant="outlined"
                    className={classes.input}
                    name="leadEmail"
                    value={
                      this.state.itemTicket &&
                      this.state.itemTicket.customFields
                        ? this.state.itemTicket.customFields.lead
                          ? this.state.itemTicket.customFields.lead.leadEmail
                          : null
                        : null
                    }
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
              </Grid>
              <Typography
                style={{
                  backgroundColor: "#d3d4d9",
                  padding: "5px 15px",
                  fontSize: 18,
                }}>
                Thông tin tiếp nhận yêu cầu
              </Typography>
              <Grid container={true} spacing={24}>
                <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Chủ đề"
                    variant="outlined"
                    className={classes.input}
                    name="Subject"
                    value={
                      this.state.itemTicket && this.state.itemTicket.attributes
                        ? this.state.itemTicket.attributes.Subject
                        : null
                    }
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Dịch vụ sử dụng"
                    variant="outlined"
                    className={classes.input}
                    name="Service__c"
                    value={
                      this.state.itemTicket &&
                      this.state.itemTicket.customFields
                        ? this.state.itemTicket.customFields.Product_Name
                          ? this.state.itemTicket.customFields.Product_Name
                          : null
                        : null
                    }
                    required
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Mô tả yêu cầu"
                    variant="outlined"
                    className={classes.input}
                    name="Description"
                    value={
                      this.state.itemTicket && this.state.itemTicket.attributes
                        ? this.state.itemTicket.attributes.Description
                        : null
                    }
                    multiline
                    rows={5}
                    required
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Mã giao dịch"
                    variant="outlined"
                    className={classes.input}
                    name="Package_text__c"
                    value={
                      this.state.itemTicket && this.state.itemTicket.attributes
                        ? this.state.itemTicket.attributes.Package_text__c
                        : null
                    }
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
              </Grid>
              <Typography
                style={{
                  backgroundColor: "#d3d4d9",
                  padding: "5px 15px",
                  fontSize: 18,
                }}>
                Chuyển ticket
              </Typography>
              <Grid container={true} spacing={24}>
                <Grid item xs={12} sm={12} md={12} xl={12} lg={12}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Đơn vị nhận ticket"
                    variant="outlined"
                    className={classes.input}
                    name="Unit__r.Name"
                    value={
                      this.state.itemTicket &&
                      this.state.itemTicket.customFields
                        ? this.state.itemTicket.customFields.Owner_Name
                          ? this.state.itemTicket.customFields.Owner_Name
                          : null
                        : null
                    }
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
              </Grid>
              <Typography
                style={{
                  backgroundColor: "#d3d4d9",
                  padding: "5px 15px",
                  fontSize: 18,
                }}>
                Thông tin Lead
                <Checkbox
                  checked={
                    this.state.itemTicket && this.state.itemTicket.customFields
                      ? this.state.itemTicket.customFields.lead
                        ? this.state.itemTicket.customFields.lead.isLead
                        : false
                      : false
                  }
                  name="isLead"
                />
              </Typography>
              <Grid container={true} spacing={24}>
                <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Trạng thái"
                    variant="outlined"
                    className={classes.input}
                    name="leadEmail"
                    value={
                      this.state.itemTicket &&
                      this.state.itemTicket.customFields
                        ? this.state.itemTicket.customFields.lead
                          ? this.state.itemTicket.customFields.lead.leadStatus
                          : null
                        : null
                    }
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Đơn vị nhận khách hàng tiềm năng"
                    variant="outlined"
                    className={classes.input}
                    name="pos"
                    value={
                      this.state.itemTicket &&
                      this.state.itemTicket.customFields
                        ? this.state.itemTicket.customFields.Pos_Name
                          ? this.state.itemTicket.customFields.Pos_Name
                          : null
                        : null
                    }
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
              </Grid>
              <DialogActions>
                <Divider />
                <Button
                  onClick={() =>
                    this.setState({
                      modalAction: false,
                      itemTicket: null,
                      item: null,
                    })
                  }
                  color="secondary"
                  className={classes.button}>
                  Hủy
                </Button>
              </DialogActions>
            </ValidatorForm>
          }
          onClose={() => this.setState({ modalAction: false })}
        />
        <Dialog
          open={this.state.isShowInfoCustomer}
          title={`Thông tin chi tiết khách hàng`}
          input={
            <Grid container className={classes.grid}>
              {customer && customer.attributes
                ? Object.keys(customer.attributes).map((item, index) => {
                    return (
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        xl={12}
                        key={index}
                        style={{ padding: 5 }}>
                        <TextField
                          id="outlined-full-width"
                          margin="normal"
                          label={item}
                          variant="outlined"
                          fullWidth={true}
                          className={classes.input}
                          value={customer.attributes[item]}
                          disabled
                          InputProps={{
                            className: classes.input,
                          }}
                        />
                      </Grid>
                    );
                  })
                : []}
            </Grid>
          }
          buttonExit={true}
          maxWidth={"xl"}
          onClose={() => this.setState({ isShowInfoCustomer: false })}
        />
        <Dialog
          open={this.state.isOpenCreateTicket}
          onClose={() => this.setState({ isOpenCreateTicket: false })}
          title="Tạo ticket"
          fullwidth={true}
          maxWidth={"md"}
          input={
            <NewTicket
              showHeader={false}
              customerInfoDefault={customer}
              onClose={() => this.setState({ isOpenCreateTicket: false })}
              idSelectedCustomerCall={this.state.idSelectedCustomerCall}
            />
          }
        />
      </React.Fragment>
    );
  }
}

AgentWorkingOutbound.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    listCampaign: state.campaign.allCampaign,
    listKnowledgeBase: state.knowledgeBase.knowledgeBases,
    listComment: state.comment.comment,
    working: state.agent.working,
    statusAgent: state.agent.statusChange,
    article: state.article.article,
    listStage: state.stage.stages,
    agentStatus: state.agent.status,
    listIndastry: state.indastry.indastries,
    coutLogsCallTelesale: state.call.count.count,
    listLogsCallTelesale: state.call.calls,
    loading: state.call.loading,
    ticketType: state.ticket.ticketType,
    getTicket: state.call.getTicket,
    ticketLoading: state.ticket.loading,
    loadingTicket: state.call.loadingTicket,
    contact: state.ticket.contact,
    employee: state.ticket.employee,
    pos: state.ticket.pos,
    product: state.ticket.product,
    saleOrder: state.ticket.saleOrder,
    package: state.ticket.package,
    countByPhone: state.ticket.countByPhone,
    modalWorking: state.clickToCall.modalWorking,
    listActiveCall: state.channel.activeCall,
    logInboundOutbound: state.call.logInboundOutbound,
    reasonSelectList: state.campaign.reasonSelectList,
    lead: state.call.lead,
    leadLoading: state.call.leadLoading,
    isShowModal: state.call.isShowModal,
    updateArrayTicket: state.call.updateArrayTicket,
    infoCustomerWithoutSocket: state.call.infoCustomerWithoutSocket,
    infoCustomer: state.call.infoCustomer,
    newIdTicket: state.call.newIdTicket,
    initStatus: state.auth.init,
  };
};

const AgentAction = connect(null, agentAction)(AgentWorkingOutbound);
const CommentAction = connect(null, commentAction)(AgentAction);
const KnowledgeBase = connect(null, knowledgeBase)(CommentAction);
const Article = connect(null, articelAction)(KnowledgeBase);
// const CallLogs = connect(null, callLogsAction)(Article)
const OutBound = connect(null, outboundCallAction)(Article);
const Stage = connect(null, stageAction)(OutBound);
const Indastry = connect(null, indastryAction)(Stage);
const Contact = connect(null, contactAction)(Indastry);
const CampaignProps = connect(null, campaignAction)(Contact);
const ClickToCall = connect(null, clickToCallAction)(CampaignProps);
const Agent = connect(null, agent)(ClickToCall);
// const LogsCallTelesale = connect(null, interactiveLogAction)(Agent);
const Ticket = connect(null, ticketAction)(Agent);
AgentWorkingOutbound = connect(mapStateToProps, mapActionsToProps)(Ticket);

export default withStyles(styles)(AgentWorkingOutbound);
